<div class="container">
    <div class="row d-flex justify-content-center">
        <div class="col-md-10">
          <div class="tabs-wrappers">
            <div class="mock-tab">
                <div class="">
                  
                    <div class="headder-courses headder-courses1 ">
                        <h3 class="cat-box" [ngClass]="{'active': tabVal == 'sectional'}"
                            (click)="changeTab('sectional')">
                           <i class="bi bi-list-check"></i>
                            <p>Full Mocks</p>
                            <div class="count">
                                {{quantMockList.length + varcMockList.length + lrdiMockList.length}}
                            </div>
                        </h3>
                    </div>
                  
    
                    <div class="headder-courses headder-courses1 mobile-none">
                        <h3 class="cat-box" [ngClass]="{'active': tabVal == 'pastpapers'}"
                            (click)="changeTab('pastpapers')">
                           <i class="bi bi-check-circle-fill"></i>
                            <p>Past Papers (Free)</p>
                            <div class="count">
                                {{pastPapers.length}}
                            </div>
                        </h3>
                    </div>
                    <div class="headder-courses headder-courses1 ">
                        <h3 class="cat-box" [ngClass]="{'active': tabVal == 'bba'}"
                            (click)="changeTab('bba')">
                            <i class="bi bi-check-circle-fill"></i>
                            <p>BBA mock tests</p>
                            <div class="count">
                                {{SETMockList.length + XETMockList.length + NPATMockList.length + CHRISTMockList.length + IPUMockList.length}}
                            </div>
                        </h3>
                    </div>
    
                    <div class="headder-courses headder-courses1 mobile-none">
                        <h3 class="cat-box" [ngClass]="{'active': tabVal == 'iim'}"
                            (click)="changeTab('iim')">
                           <i class="bi bi-check-circle-fill"></i>
                            <p>IIM BBA Mocks</p>
                            <div class="count">
                                {{iim.length}}
                            </div>
                        </h3>
                    </div>
    
                    <div class="headder-courses headder-courses1 mobile-none">
                        <h3 class="cat-box" [ngClass]="{'active': tabVal == 'pyqmock'}"
                            (click)="changeTab('pyqmock')">
                           <i class="bi bi-check-circle-fill"></i>
                            <p>INDORE PYQ Topicwise</p>
                            <div class="count">
                                {{pyqmock.length}}
                            </div>
                        </h3>
                    </div>
                    <div class="headder-courses headder-courses1 mobile-none">
                        <h3 class="cat-box" [ngClass]="{'active': tabVal == 'Rohtak'}"
                            (click)="changeTab('Rohtak')">
                           <i class="bi bi-check-circle-fill"></i>
                            <p>IPMAT ROHTAK</p>
                            <div class="count">
                                {{Rohtak.length}}
                            </div>
                        </h3>
                    </div>
    
                    <div class="headder-courses headder-courses1 mobile-none">
                        <h3 class="cat-box" [ngClass]="{'active': tabVal == 'INDOREQA'}"
                            (click)="changeTab('INDOREQA')">
                           <i class="bi bi-check-circle-fill"></i>
                            <p>INDORE QA SA</p>
                            <div class="count">
                                {{INDOREQA.length}}
                            </div>
                        </h3>
                    </div>
                    <div class="headder-courses headder-courses1 mobile-none">
                        <h3 class="cat-box" [ngClass]="{'active': tabVal == 'INDOREQAMCQ'}"
                            (click)="changeTab('INDOREQAMCQ')">
                            <i class="bi bi-check-circle-fill"></i>
                            <p>INDORE QA MCQ Sectional</p>
                            <div class="count">
                                {{INDOREQAMCQ.length}}
                            </div>
                        </h3>
                    </div>

                    <div class="headder-courses headder-courses1 mobile-none">
                        <h3 class="cat-box" [ngClass]="{'active': tabVal == 'IndoreVA'}"
                            (click)="changeTab('IndoreVA')">
                          <i class="bi bi-check-circle-fill"></i>
                            <p>IPMAT Indore VA Sectional</p>
                            <div class="count">
                                {{IndoreVA.length}}
                            </div>
                        </h3>
                    </div>

                     <div class="headder-courses headder-courses1 mobile-none">
                        <h3 class="cat-box" [ngClass]="{'active': tabVal == 'Kozhikode'}"
                            (click)="changeTab('Kozhikode')">
                          <i class="bi bi-check-circle-fill"></i>
                            <p>IIM Kozhikode</p>
                            <div class="count">
                                {{Kozhikode.length}}
                            </div>
                        </h3>
                    </div>
    
                </div>
              
    
            </div>
            <div class="mock-tab ng-mock-tab">
                    <ng-container *ngIf="tabVal == 'sectional'">
                        <div class="d-flex justify-content-center">
                            <div class="headder-courses headder-courses1 ">
                                <h3 class="cat-box " [ngClass]="{'active': tabVal1 == 'quant'}"
                                    (click)="changeTab1('quant')">
    
                                    <p>IPMAT Indore</p>
                                    <div class="count">
                                        {{quantMockList.length}}
                                    </div>
                                </h3>
                            </div>
                            <div class="headder-courses headder-courses1 ">
                                <h3 class="cat-box" [ngClass]="{'active': tabVal1 == 'varc'}"
                                    (click)="changeTab1('varc')">
                                    <p>IPMAT Rohtak</p>
                                    <div class="count">
                                        {{varcMockList.length}}
                                    </div>
                                </h3>
                            </div>
                            <div class="headder-courses headder-courses1 ">
                                <h3 class="cat-box" [ngClass]="{'active': tabVal1 == 'lrdi'}"
                                    (click)="changeTab1('lrdi')">
    
                                    <p>JIPMAT</p>
                                    <div class="count">
                                        {{lrdiMockList.length}}
                                    </div>
                                </h3>
                            </div>
                        </div>
                    </ng-container>
    
                    <ng-container *ngIf="tabVal == 'bba'">
                        <div class="d-flex justify-content-center">
                            <div class="headder-courses headder-courses1 ">
                                <h3 class="cat-box " [ngClass]="{'active': tabVal1 == 'SET'}"
                                    (click)="changeTab1('SET')">
                                    <p>SET BBA</p>
                                    <div class="count">
                                        {{SETMockList.length}}
                                    </div>
                                </h3>
                            </div>
                        
                            <div class="headder-courses headder-courses1 ">
                                <h3 class="cat-box" [ngClass]="{'active': tabVal1 == 'NPAT'}"
                                    (click)="changeTab1('NPAT')">
                                    <p>NPAT BBA</p>
                                    <div class="count">
                                        {{NPATMockList.length}}
                                    </div>
                                </h3>
                            </div>
                            <div class="headder-courses headder-courses1 ">
                                <h3 class="cat-box" [ngClass]="{'active': tabVal1 == 'CHRIST'}"
                                    (click)="changeTab1('CHRIST')">
                                    <p>CHRIST BBA</p>
                                    <div class="count">
                                        {{CHRISTMockList.length}}
                                    </div>
                                </h3>
                            </div>
    
                            <div class="headder-courses headder-courses1 ">
                                <h3 class="cat-box" [ngClass]="{'active': tabVal1 == 'BMSBBA'}"
                                    (click)="changeTab1('BMSBBA')">
                                    <p>XAVIER'S BMS BBA</p>
                                    <div class="count">
                                        {{BMSBBAMockList.length}}
                                    </div>
                                </h3>
                            </div>
                            <div class="headder-courses headder-courses1 ">
                                <h3 class="cat-box" [ngClass]="{'active': tabVal1 == 'CETBBA'}"
                                    (click)="changeTab1('CETBBA')">
                                    <p>IPU CET BBA</p>
                                    <div class="count">
                                        {{CETBBAMockList.length}}
                                    </div>
                                </h3>
                            </div>
                        
                        </div>
                    </ng-container>
             </div>
          </div>
        </div>
        <div class="col-md-9 full_width_tab">
    
       
            <p class="desk-none tab-text"><span>This mock platform is made for desktops/laptop only.</span>
                Kindly visit this page from your desktop/laptop to
                attempt free or purchased mocks.</p>
    
            <div class="career_opens mt-4">
    
                <ul *ngIf="tabVal == 'pyqmock'">
                    <li class="d-flex justify-content-between" *ngFor="let mock of pyqmock">
                        <div class="caree_title d-flex">
                            <h3>{{mock.name}}</h3>
                            <p *ngIf="!mock.launch" style="color: #f44336">Live Now</p>
                            <p *ngIf="mock.launch">Start Date {{mock.launch}}</p>
                        </div>
                        <ng-container *ngIf="!mock.launch && !mock.paid; else paidBtn">
                            <div class="mobile-none">
                                <div *ngIf="mock.attemptAllowed > 1">
                                    <div class="career_btn d-flex align-items-end">
    
                                        <div *ngFor="let attempt of mock.attemptList; let i = index">
                                            <div>
                                                <p *ngIf="attempt.mockStatus == 'paused' || attempt.mockStatus == 'resumed' || (attempt.mockStatus == 'started' && attempt.attemptId)"
                                                    style="color: #ffffff !important;
                                                text-align: center;
                                                margin-bottom: 10px;
                                                font-size: 14px;">Attempt {{i+1}}</p>
                                                <button
                                                    *ngIf="attempt.mockStatus == 'paused' || attempt.mockStatus == 'resumed' || (attempt.mockStatus == 'started' && attempt.attemptId)"
                                                    (click)="resume(mock, attempt, i)"
                                                    style="background-color: #fff;border:1px solid #fff;color:#000;margin-right:5px"
                                                    mat-flat-button color="primary">
                                                    <img src="https://media.iquanta.in/ui_images/rocket.png"
                                                        alt=""
                                                        style="width: 15px; margin-right: 10px;">Resume</button>
                                            </div>
    
                                            <p *ngIf="attempt.mockStatus == 'completed'" style="color: #ffffff !important;
                                          text-align: center;
                                          margin-bottom: 10px;
                                          font-size: 14px;">Attempt {{i+1}}</p>
                                            <button *ngIf="attempt.mockStatus == 'completed'"
                                                (click)="viewanalysis(mock, attempt, i)"
                                                style="background-color: #fff;border:1px solid #fff;color:#000;margin-right:5px"
                                                mat-flat-button color="primary">
                                                View
                                                Analysis</button>
                                        </div>
    
                                        <div *ngIf="mock.attemptAllowed && mock.attemptAllowed > mock?.attemptList?.length &&
                                            (mock.attemptList[mock.attemptList.length - 1].mockStatus == 'completed' 
                                            || !mock.attemptList[mock.attemptList.length - 1].mockStatus ) || (mock.attemptList[mock.attemptList.length - 1].mockStatus == 'started' &&
                                            !mock.attemptList[mock.attemptList.length - 1].attemptId)  ">
                                            <button
                                                *ngIf="!mock.attemptList[mock.attemptList.length - 1].attemptId"
                                                (click)="startMock(mock)"
                                                style="background-color: #fff;border:1px solid #fff;color:#000;margin-right:0"
                                                mat-flat-button color="primary">
                                                <span><img
                                                        src="https://media.iquanta.in/ui_images/rocket.png"></span>Start
                                                Mock</button>
                                            <button
                                                *ngIf="mock.attemptList[mock.attemptList.length - 1].attemptId"
                                                (click)="startMock(mock)"
                                                style="background-color: #ffe401;border:1px solid #ffe401;color:#000;margin-right:0"
                                                mat-flat-button color="primary">
                                                <span><img
                                                        src="https://media.iquanta.in/ui_images/rocket.png"></span>Reattempt</button>
                                        </div>
    
                                    </div>
                                </div>
                                <div *ngIf="mock.attemptAllowed == 1">
                                    <div class="career_btn d-flex align-items-end">
                                        <button *ngIf="!mock.attemptList[0].attemptId" (click)="startMock(mock)"
                                            style="background-color: #fff;border:1px solid #fff;color:#000;margin-right:0"
                                            mat-flat-button color="primary">
                                            <span><img
                                                    src="https://media.iquanta.in/ui_images/rocket.png"></span>Start
                                            Mock</button>
    
                                        <button
                                            *ngIf="mock.attemptList[0].mockStatus == 'paused' || mock.attemptList[0].mockStatus == 'resumed' || mock.attemptList[0].mockStatus == 'started'"
                                            (click)="resume(mock, mock.attemptList[0], '0')"
                                            style="background-color: #fff;border:1px solid #fff;color:#000;margin-right:0"
                                            mat-flat-button color="primary">
                                            <span><img
                                                    src="https://media.iquanta.in/ui_images/rocket.png"></span>Resume</button>
    
                                        <button *ngIf="mock.attemptList[0].mockStatus == 'completed'"
                                            (click)="viewanalysis(mock, mock.attemptList[0], '0')"
                                            style="background-color: #fff;border:1px solid #fff;color:#000;margin-right:0"
                                            mat-flat-button color="primary">
                                            <span><img
                                                    src="https://media.iquanta.in/ui_images/rocket.png"></span>View
                                            Analysis</button>
                                    </div>
                                </div>
                                <div *ngIf="!token || !mock.attemptAllowed">
                                    <div class="career_btn d-flex align-items-end">
                                        <button (click)="startMock(mock)"
                                            style="background-color: #fff;border:1px solid #fff;color:#000;margin-right:0"
                                            mat-flat-button color="primary">
                                            <span><img
                                                    src="https://media.iquanta.in/ui_images/rocket.png"></span>Start
                                            Mock</button>
                                    </div>
                                </div>
                            </div>
                            <div class="desk-none">
                                <div class="career_btn d-flex align-items-end">
                                    <button style="background-color: #fff;border:1px solid #fff;
                                            color:#000;margin-right:0;    line-height: initial;
                                            padding: 0;height:auto;
                                            " mat-flat-button color="primary">
                                        Attempt From Desktop</button>
                                </div>
                            </div>
                        </ng-container>
                        <ng-template #paidBtn>
                            <div class="career_btn d-flex align-items-start">
                                <button *ngIf="mock.paid"
                                    style="background-color: #f44336;border:1px solid #f44336"
                                    (click)="goto('packages')" mat-flat-button color="primary">Paid</button>
    
                                <button [matTooltip]="'This free mock will be available from '+mock.launch"
                                    *ngIf="!mock.paid" #myTooltip="matTooltip" (click)="displayTooltip()"
                                    style="background-color: #11830d;border:1px solid #11830d" mat-flat-button
                                    color="primary">Purchased</button>
    
                                <button *ngIf="mock.lock" class="mobile-none"
                                    style="background-color: #fff;border:1px solid #fff;color:#000;margin-right:0"
                                    mat-flat-button color="primary">
                                    <i class="bi bi-lock-fill"></i> Locked</button>
                                <ng-container *ngIf="mock.lock">
                                    <button class="desk-none"
                                        style="background-color: #fff;border:1px solid #fff;color:#000;margin-right:0"
                                        mat-flat-button color="primary">
                                        <i class="bi bi-lock-fill"></i> </button>
                                </ng-container>
                            </div>
                        </ng-template>
    
                    </li>
    
    
    
                </ul>
    

                 <ul *ngIf="tabVal == 'Kozhikode'">
                    <li class="d-flex justify-content-between" *ngFor="let mock of Kozhikode">
                        <div class="caree_title d-flex">
                            <h3>{{mock.name}}</h3>
                            <p *ngIf="!mock.launch" style="color: #f44336">Live Now</p>
                            <p *ngIf="mock.launch">Start Date {{mock.launch}}</p>
                        </div>
                        <ng-container *ngIf="!mock.launch && !mock.paid; else paidBtn">
                            <div class="mobile-none">
                                <div *ngIf="mock.attemptAllowed > 1">
                                    <div class="career_btn d-flex align-items-end">
    
                                        <div *ngFor="let attempt of mock.attemptList; let i = index">
                                            <div>
                                                <p *ngIf="attempt.mockStatus == 'paused' || attempt.mockStatus == 'resumed' || (attempt.mockStatus == 'started' && attempt.attemptId)"
                                                    style="color: #ffffff !important;
                                                text-align: center;
                                                margin-bottom: 10px;
                                                font-size: 14px;">Attempt {{i+1}}</p>
                                                <button
                                                    *ngIf="attempt.mockStatus == 'paused' || attempt.mockStatus == 'resumed' || (attempt.mockStatus == 'started' && attempt.attemptId)"
                                                    (click)="resume(mock, attempt, i)"
                                                    style="background-color: #fff;border:1px solid #fff;color:#000;margin-right:5px"
                                                    mat-flat-button color="primary">
                                                    <img src="https://media.iquanta.in/ui_images/rocket.png"
                                                        alt=""
                                                        style="width: 15px; margin-right: 10px;">Resume</button>
                                            </div>
    
                                            <p *ngIf="attempt.mockStatus == 'completed'" style="color: #ffffff !important;
                                          text-align: center;
                                          margin-bottom: 10px;
                                          font-size: 14px;">Attempt {{i+1}}</p>
                                            <button *ngIf="attempt.mockStatus == 'completed'"
                                                (click)="viewanalysis(mock, attempt, i)"
                                                style="background-color: #fff;border:1px solid #fff;color:#000;margin-right:5px"
                                                mat-flat-button color="primary">
                                                View
                                                Analysis</button>
                                        </div>
    
                                        <div *ngIf="mock.attemptAllowed && mock.attemptAllowed > mock?.attemptList?.length &&
                                            (mock.attemptList[mock.attemptList.length - 1].mockStatus == 'completed' 
                                            || !mock.attemptList[mock.attemptList.length - 1].mockStatus ) || (mock.attemptList[mock.attemptList.length - 1].mockStatus == 'started' &&
                                            !mock.attemptList[mock.attemptList.length - 1].attemptId)  ">
                                            <button
                                                *ngIf="!mock.attemptList[mock.attemptList.length - 1].attemptId"
                                                (click)="startMock(mock)"
                                                style="background-color: #fff;border:1px solid #fff;color:#000;margin-right:0"
                                                mat-flat-button color="primary">
                                                <span><img
                                                        src="https://media.iquanta.in/ui_images/rocket.png"></span>Start
                                                Mock</button>
                                            <button
                                                *ngIf="mock.attemptList[mock.attemptList.length - 1].attemptId"
                                                (click)="startMock(mock)"
                                                style="background-color: #ffe401;border:1px solid #ffe401;color:#000;margin-right:0"
                                                mat-flat-button color="primary">
                                                <span><img
                                                        src="https://media.iquanta.in/ui_images/rocket.png"></span>Reattempt</button>
                                        </div>
    
                                    </div>
                                </div>
                                <div *ngIf="mock.attemptAllowed == 1">
                                    <div class="career_btn d-flex align-items-end">
                                        <button *ngIf="!mock.attemptList[0].attemptId" (click)="startMock(mock)"
                                            style="background-color: #fff;border:1px solid #fff;color:#000;margin-right:0"
                                            mat-flat-button color="primary">
                                            <span><img
                                                    src="https://media.iquanta.in/ui_images/rocket.png"></span>Start
                                            Mock</button>
    
                                        <button
                                            *ngIf="mock.attemptList[0].mockStatus == 'paused' || mock.attemptList[0].mockStatus == 'resumed' || mock.attemptList[0].mockStatus == 'started'"
                                            (click)="resume(mock, mock.attemptList[0], '0')"
                                            style="background-color: #fff;border:1px solid #fff;color:#000;margin-right:0"
                                            mat-flat-button color="primary">
                                            <span><img
                                                    src="https://media.iquanta.in/ui_images/rocket.png"></span>Resume</button>
    
                                        <button *ngIf="mock.attemptList[0].mockStatus == 'completed'"
                                            (click)="viewanalysis(mock, mock.attemptList[0], '0')"
                                            style="background-color: #fff;border:1px solid #fff;color:#000;margin-right:0"
                                            mat-flat-button color="primary">
                                            <span><img
                                                    src="https://media.iquanta.in/ui_images/rocket.png"></span>View
                                            Analysis</button>
                                    </div>
                                </div>
                                <div *ngIf="!token || !mock.attemptAllowed">
                                    <div class="career_btn d-flex align-items-end">
                                        <button (click)="startMock(mock)"
                                            style="background-color: #fff;border:1px solid #fff;color:#000;margin-right:0"
                                            mat-flat-button color="primary">
                                            <span><img
                                                    src="https://media.iquanta.in/ui_images/rocket.png"></span>Start
                                            Mock</button>
                                    </div>
                                </div>
                            </div>
                            <div class="desk-none">
                                <div class="career_btn d-flex align-items-end">
                                    <button style="background-color: #fff;border:1px solid #fff;
                                            color:#000;margin-right:0;    line-height: initial;
                                            padding: 0;height:auto;
                                            " mat-flat-button color="primary">
                                        Attempt From Desktop</button>
                                </div>
                            </div>
                        </ng-container>
                        <ng-template #paidBtn>
                            <div class="career_btn d-flex align-items-start">
                                <button *ngIf="mock.paid"
                                    style="background-color: #f44336;border:1px solid #f44336"
                                    (click)="goto('packages')" mat-flat-button color="primary">Paid</button>
    
                                <button [matTooltip]="'This free mock will be available from '+mock.launch"
                                    *ngIf="!mock.paid" #myTooltip="matTooltip" (click)="displayTooltip()"
                                    style="background-color: #11830d;border:1px solid #11830d" mat-flat-button
                                    color="primary">Purchased</button>
    
                                <button *ngIf="mock.lock" class="mobile-none"
                                    style="background-color: #fff;border:1px solid #fff;color:#000;margin-right:0"
                                    mat-flat-button color="primary">
                                   <i class="bi bi-lock-fill"></i> Locked</button>
                                <ng-container *ngIf="mock.lock">
                                    <button class="desk-none"
                                        style="background-color: #fff;border:1px solid #fff;color:#000;margin-right:0"
                                        mat-flat-button color="primary">
                                        <i class="bi bi-lock-fill"></i> </button>
                                </ng-container>
                            </div>
                        </ng-template>
    
                    </li>
    
    
    
                </ul>
    
                <ul *ngIf="tabVal == 'Rohtak'">
                    <li class="d-flex justify-content-between" *ngFor="let mock of Rohtak">
                        <div class="caree_title d-flex">
                            <h3>{{mock.name}}</h3>
                            <p *ngIf="!mock.launch" style="color: #f44336">Live Now</p>
                            <p *ngIf="mock.launch">Start Date {{mock.launch}}</p>
                        </div>
                        <ng-container *ngIf="!mock.launch && !mock.paid; else paidBtn">
                            <div class="mobile-none">
                                <div *ngIf="mock.attemptAllowed > 1">
                                    <div class="career_btn d-flex align-items-end">
    
                                        <div *ngFor="let attempt of mock.attemptList; let i = index">
                                            <div>
                                                <p *ngIf="attempt.mockStatus == 'paused' || attempt.mockStatus == 'resumed' || (attempt.mockStatus == 'started' && attempt.attemptId)"
                                                    style="color: #ffffff !important;
                                                text-align: center;
                                                margin-bottom: 10px;
                                                font-size: 14px;">Attempt {{i+1}}</p>
                                                <button
                                                    *ngIf="attempt.mockStatus == 'paused' || attempt.mockStatus == 'resumed' || (attempt.mockStatus == 'started' && attempt.attemptId)"
                                                    (click)="resume(mock, attempt, i)"
                                                    style="background-color: #fff;border:1px solid #fff;color:#000;margin-right:5px"
                                                    mat-flat-button color="primary">
                                                    <img src="https://media.iquanta.in/ui_images/rocket.png"
                                                        alt=""
                                                        style="width: 15px; margin-right: 10px;">Resume</button>
                                            </div>
    
                                            <p *ngIf="attempt.mockStatus == 'completed'" style="color: #ffffff !important;
                                          text-align: center;
                                          margin-bottom: 10px;
                                          font-size: 14px;">Attempt {{i+1}}</p>
                                            <button *ngIf="attempt.mockStatus == 'completed'"
                                                (click)="viewanalysis(mock, attempt, i)"
                                                style="background-color: #fff;border:1px solid #fff;color:#000;margin-right:5px"
                                                mat-flat-button color="primary">
                                                View
                                                Analysis</button>
                                        </div>
    
                                        <div *ngIf="mock.attemptAllowed && mock.attemptAllowed > mock?.attemptList?.length &&
                                            (mock.attemptList[mock.attemptList.length - 1].mockStatus == 'completed' 
                                            || !mock.attemptList[mock.attemptList.length - 1].mockStatus ) || (mock.attemptList[mock.attemptList.length - 1].mockStatus == 'started' &&
                                            !mock.attemptList[mock.attemptList.length - 1].attemptId)  ">
                                            <button
                                                *ngIf="!mock.attemptList[mock.attemptList.length - 1].attemptId"
                                                (click)="startMock(mock)"
                                                style="background-color: #fff;border:1px solid #fff;color:#000;margin-right:0"
                                                mat-flat-button color="primary">
                                                <span><img
                                                        src="https://media.iquanta.in/ui_images/rocket.png"></span>Start
                                                Mock</button>
                                            <button
                                                *ngIf="mock.attemptList[mock.attemptList.length - 1].attemptId"
                                                (click)="startMock(mock)"
                                                style="background-color: #ffe401;border:1px solid #ffe401;color:#000;margin-right:0"
                                                mat-flat-button color="primary">
                                                <span><img
                                                        src="https://media.iquanta.in/ui_images/rocket.png"></span>Reattempt</button>
                                        </div>
    
                                    </div>
                                </div>
                                <div *ngIf="mock.attemptAllowed == 1">
                                    <div class="career_btn d-flex align-items-end">
                                        <button *ngIf="!mock.attemptList[0].attemptId" (click)="startMock(mock)"
                                            style="background-color: #fff;border:1px solid #fff;color:#000;margin-right:0"
                                            mat-flat-button color="primary">
                                            <span><img
                                                    src="https://media.iquanta.in/ui_images/rocket.png"></span>Start
                                            Mock</button>
    
                                        <button
                                            *ngIf="mock.attemptList[0].mockStatus == 'paused' || mock.attemptList[0].mockStatus == 'resumed' || mock.attemptList[0].mockStatus == 'started'"
                                            (click)="resume(mock, mock.attemptList[0], '0')"
                                            style="background-color: #fff;border:1px solid #fff;color:#000;margin-right:0"
                                            mat-flat-button color="primary">
                                            <span><img
                                                    src="https://media.iquanta.in/ui_images/rocket.png"></span>Resume</button>
    
                                        <button *ngIf="mock.attemptList[0].mockStatus == 'completed'"
                                            (click)="viewanalysis(mock, mock.attemptList[0], '0')"
                                            style="background-color: #fff;border:1px solid #fff;color:#000;margin-right:0"
                                            mat-flat-button color="primary">
                                            <span><img
                                                    src="https://media.iquanta.in/ui_images/rocket.png"></span>View
                                            Analysis</button>
                                    </div>
                                </div>
                                <div *ngIf="!token || !mock.attemptAllowed">
                                    <div class="career_btn d-flex align-items-end">
                                        <button (click)="startMock(mock)"
                                            style="background-color: #fff;border:1px solid #fff;color:#000;margin-right:0"
                                            mat-flat-button color="primary">
                                            <span><img
                                                    src="https://media.iquanta.in/ui_images/rocket.png"></span>Start
                                            Mock</button>
                                    </div>
                                </div>
                            </div>
                            <div class="desk-none">
                                <div class="career_btn d-flex align-items-end">
                                    <button style="background-color: #fff;border:1px solid #fff;
                                            color:#000;margin-right:0;    line-height: initial;
                                            padding: 0;height:auto;
                                            " mat-flat-button color="primary">
                                        Attempt From Desktop</button>
                                </div>
                            </div>
                        </ng-container>
                        <ng-template #paidBtn>
                            <div class="career_btn d-flex align-items-start">
                                <button *ngIf="mock.paid"
                                    style="background-color: #f44336;border:1px solid #f44336"
                                    (click)="goto('packages')" mat-flat-button color="primary">Paid</button>
    
                                <button [matTooltip]="'This free mock will be available from '+mock.launch"
                                    *ngIf="!mock.paid" #myTooltip="matTooltip" (click)="displayTooltip()"
                                    style="background-color: #11830d;border:1px solid #11830d" mat-flat-button
                                    color="primary">Purchased</button>
    
                                <button *ngIf="mock.lock" class="mobile-none"
                                    style="background-color: #fff;border:1px solid #fff;color:#000;margin-right:0"
                                    mat-flat-button color="primary">
                                   <i class="bi bi-lock-fill"></i> Locked</button>
                                <ng-container *ngIf="mock.lock">
                                    <button class="desk-none"
                                        style="background-color: #fff;border:1px solid #fff;color:#000;margin-right:0"
                                        mat-flat-button color="primary">
                                        <i class="bi bi-lock-fill"></i> </button>
                                </ng-container>
                            </div>
                        </ng-template>
    
                    </li>
    
    
    
                </ul>
    
    
                <ul *ngIf="tabVal == 'INDOREQA'">
                    <li class="d-flex justify-content-between" *ngFor="let mock of INDOREQA">
                        <div class="caree_title d-flex">
                            <h3>{{mock.name}}</h3>
                            <p *ngIf="!mock.launch" style="color: #f44336">Live Now</p>
                            <p *ngIf="mock.launch">Start Date {{mock.launch}}</p>
                        </div>
                        <ng-container *ngIf="!mock.launch && !mock.paid; else paidBtn">
                            <div class="mobile-none">
                                <div *ngIf="mock.attemptAllowed > 1">
                                    <div class="career_btn d-flex align-items-end">
    
                                        <div *ngFor="let attempt of mock.attemptList; let i = index">
                                            <div>
                                                <p *ngIf="attempt.mockStatus == 'paused' || attempt.mockStatus == 'resumed' || (attempt.mockStatus == 'started' && attempt.attemptId)"
                                                    style="color: #ffffff !important;
                                                text-align: center;
                                                margin-bottom: 10px;
                                                font-size: 14px;">Attempt {{i+1}}</p>
                                                <button
                                                    *ngIf="attempt.mockStatus == 'paused' || attempt.mockStatus == 'resumed' || (attempt.mockStatus == 'started' && attempt.attemptId)"
                                                    (click)="resume(mock, attempt, i)"
                                                    style="background-color: #fff;border:1px solid #fff;color:#000;margin-right:5px"
                                                    mat-flat-button color="primary">
                                                    <img src="https://media.iquanta.in/ui_images/rocket.png"
                                                        alt=""
                                                        style="width: 15px; margin-right: 10px;">Resume</button>
                                            </div>
    
                                            <p *ngIf="attempt.mockStatus == 'completed'" style="color: #ffffff !important;
                                          text-align: center;
                                          margin-bottom: 10px;
                                          font-size: 14px;">Attempt {{i+1}}</p>
                                            <button *ngIf="attempt.mockStatus == 'completed'"
                                                (click)="viewanalysis(mock, attempt, i)"
                                                style="background-color: #fff;border:1px solid #fff;color:#000;margin-right:5px"
                                                mat-flat-button color="primary">
                                                View
                                                Analysis</button>
                                        </div>
    
                                        <div *ngIf="mock.attemptAllowed && mock.attemptAllowed > mock?.attemptList?.length &&
                                            (mock.attemptList[mock.attemptList.length - 1].mockStatus == 'completed' 
                                            || !mock.attemptList[mock.attemptList.length - 1].mockStatus ) || (mock.attemptList[mock.attemptList.length - 1].mockStatus == 'started' &&
                                            !mock.attemptList[mock.attemptList.length - 1].attemptId)  ">
                                            <button
                                                *ngIf="!mock.attemptList[mock.attemptList.length - 1].attemptId"
                                                (click)="startMock(mock)"
                                                style="background-color: #fff;border:1px solid #fff;color:#000;margin-right:0"
                                                mat-flat-button color="primary">
                                                <span><img
                                                        src="https://media.iquanta.in/ui_images/rocket.png"></span>Start
                                                Mock</button>
                                            <button
                                                *ngIf="mock.attemptList[mock.attemptList.length - 1].attemptId"
                                                (click)="startMock(mock)"
                                                style="background-color: #ffe401;border:1px solid #ffe401;color:#000;margin-right:0"
                                                mat-flat-button color="primary">
                                                <span><img
                                                        src="https://media.iquanta.in/ui_images/rocket.png"></span>Reattempt</button>
                                        </div>
    
                                    </div>
                                </div>
                                <div *ngIf="mock.attemptAllowed == 1">
                                    <div class="career_btn d-flex align-items-end">
                                        <button *ngIf="!mock.attemptList[0].attemptId" (click)="startMock(mock)"
                                            style="background-color: #fff;border:1px solid #fff;color:#000;margin-right:0"
                                            mat-flat-button color="primary">
                                            <span><img
                                                    src="https://media.iquanta.in/ui_images/rocket.png"></span>Start
                                            Mock</button>
    
                                        <button
                                            *ngIf="mock.attemptList[0].mockStatus == 'paused' || mock.attemptList[0].mockStatus == 'resumed' || mock.attemptList[0].mockStatus == 'started'"
                                            (click)="resume(mock, mock.attemptList[0], '0')"
                                            style="background-color: #fff;border:1px solid #fff;color:#000;margin-right:0"
                                            mat-flat-button color="primary">
                                            <span><img
                                                    src="https://media.iquanta.in/ui_images/rocket.png"></span>Resume</button>
    
                                        <button *ngIf="mock.attemptList[0].mockStatus == 'completed'"
                                            (click)="viewanalysis(mock, mock.attemptList[0], '0')"
                                            style="background-color: #fff;border:1px solid #fff;color:#000;margin-right:0"
                                            mat-flat-button color="primary">
                                            <span><img
                                                    src="https://media.iquanta.in/ui_images/rocket.png"></span>View
                                            Analysis</button>
                                    </div>
                                </div>
                                <div *ngIf="!token || !mock.attemptAllowed">
                                    <div class="career_btn d-flex align-items-end">
                                        <button (click)="startMock(mock)"
                                            style="background-color: #fff;border:1px solid #fff;color:#000;margin-right:0"
                                            mat-flat-button color="primary">
                                            <span><img
                                                    src="https://media.iquanta.in/ui_images/rocket.png"></span>Start
                                            Mock</button>
                                    </div>
                                </div>
                            </div>
                            <div class="desk-none">
                                <div class="career_btn d-flex align-items-end">
                                    <button style="background-color: #fff;border:1px solid #fff;
                                            color:#000;margin-right:0;    line-height: initial;
                                            padding: 0;height:auto;
                                            " mat-flat-button color="primary">
                                        Attempt From Desktop</button>
                                </div>
                            </div>
                        </ng-container>
                        <ng-template #paidBtn>
                            <div class="career_btn d-flex align-items-start">
                                <button *ngIf="mock.paid"
                                    style="background-color: #f44336;border:1px solid #f44336"
                                    (click)="goto('packages')" mat-flat-button color="primary">Paid</button>
    
                                <button [matTooltip]="'This free mock will be available from '+mock.launch"
                                    *ngIf="!mock.paid" #myTooltip="matTooltip" (click)="displayTooltip()"
                                    style="background-color: #11830d;border:1px solid #11830d" mat-flat-button
                                    color="primary">Purchased</button>
    
                                <button *ngIf="mock.lock" class="mobile-none"
                                    style="background-color: #fff;border:1px solid #fff;color:#000;margin-right:0"
                                    mat-flat-button color="primary">
                                    <i class="bi bi-lock-fill"></i> Locked</button>
                                <ng-container *ngIf="mock.lock">
                                    <button class="desk-none"
                                        style="background-color: #fff;border:1px solid #fff;color:#000;margin-right:0"
                                        mat-flat-button color="primary">
                                        <i class="bi bi-lock-fill"></i> </button>
                                </ng-container>
                            </div>
                        </ng-template>
    
                    </li>
    
    
    
                </ul>
    
                <ul *ngIf="tabVal == 'INDOREQAMCQ'">
                    <li class="d-flex justify-content-between" *ngFor="let mock of INDOREQAMCQ">
                        <div class="caree_title d-flex">
                            <h3>{{mock.name}}</h3>
                            <p *ngIf="!mock.launch" style="color: #f44336">Live Now</p>
                            <p *ngIf="mock.launch">Start Date {{mock.launch}}</p>
                        </div>
                        <ng-container *ngIf="!mock.launch && !mock.paid; else paidBtn">
                            <div class="mobile-none">
                                <div *ngIf="mock.attemptAllowed > 1">
                                    <div class="career_btn d-flex align-items-end">
    
                                        <div *ngFor="let attempt of mock.attemptList; let i = index">
                                            <div>
                                                <p *ngIf="attempt.mockStatus == 'paused' || attempt.mockStatus == 'resumed' || (attempt.mockStatus == 'started' && attempt.attemptId)"
                                                    style="color: #ffffff !important;
                                                text-align: center;
                                                margin-bottom: 10px;
                                                font-size: 14px;">Attempt {{i+1}}</p>
                                                <button
                                                    *ngIf="attempt.mockStatus == 'paused' || attempt.mockStatus == 'resumed' || (attempt.mockStatus == 'started' && attempt.attemptId)"
                                                    (click)="resume(mock, attempt, i)"
                                                    style="background-color: #fff;border:1px solid #fff;color:#000;margin-right:5px"
                                                    mat-flat-button color="primary">
                                                    <img src="https://media.iquanta.in/ui_images/rocket.png"
                                                        alt=""
                                                        style="width: 15px; margin-right: 10px;">Resume</button>
                                            </div>
    
                                            <p *ngIf="attempt.mockStatus == 'completed'" style="color: #ffffff !important;
                                          text-align: center;
                                          margin-bottom: 10px;
                                          font-size: 14px;">Attempt {{i+1}}</p>
                                            <button *ngIf="attempt.mockStatus == 'completed'"
                                                (click)="viewanalysis(mock, attempt, i)"
                                                style="background-color: #fff;border:1px solid #fff;color:#000;margin-right:5px"
                                                mat-flat-button color="primary">
                                                View
                                                Analysis</button>
                                        </div>
    
                                        <div *ngIf="mock.attemptAllowed && mock.attemptAllowed > mock?.attemptList?.length &&
                                            (mock.attemptList[mock.attemptList.length - 1].mockStatus == 'completed' 
                                            || !mock.attemptList[mock.attemptList.length - 1].mockStatus ) || (mock.attemptList[mock.attemptList.length - 1].mockStatus == 'started' &&
                                            !mock.attemptList[mock.attemptList.length - 1].attemptId)  ">
                                            <button
                                                *ngIf="!mock.attemptList[mock.attemptList.length - 1].attemptId"
                                                (click)="startMock(mock)"
                                                style="background-color: #fff;border:1px solid #fff;color:#000;margin-right:0"
                                                mat-flat-button color="primary">
                                                <span><img
                                                        src="https://media.iquanta.in/ui_images/rocket.png"></span>Start
                                                Mock</button>
                                            <button
                                                *ngIf="mock.attemptList[mock.attemptList.length - 1].attemptId"
                                                (click)="startMock(mock)"
                                                style="background-color: #ffe401;border:1px solid #ffe401;color:#000;margin-right:0"
                                                mat-flat-button color="primary">
                                                <span><img
                                                        src="https://media.iquanta.in/ui_images/rocket.png"></span>Reattempt</button>
                                        </div>
    
                                    </div>
                                </div>
                                <div *ngIf="mock.attemptAllowed == 1">
                                    <div class="career_btn d-flex align-items-end">
                                        <button *ngIf="!mock.attemptList[0].attemptId" (click)="startMock(mock)"
                                            style="background-color: #fff;border:1px solid #fff;color:#000;margin-right:0"
                                            mat-flat-button color="primary">
                                            <span><img
                                                    src="https://media.iquanta.in/ui_images/rocket.png"></span>Start
                                            Mock</button>
    
                                        <button
                                            *ngIf="mock.attemptList[0].mockStatus == 'paused' || mock.attemptList[0].mockStatus == 'resumed' || mock.attemptList[0].mockStatus == 'started'"
                                            (click)="resume(mock, mock.attemptList[0], '0')"
                                            style="background-color: #fff;border:1px solid #fff;color:#000;margin-right:0"
                                            mat-flat-button color="primary">
                                            <span><img
                                                    src="https://media.iquanta.in/ui_images/rocket.png"></span>Resume</button>
    
                                        <button *ngIf="mock.attemptList[0].mockStatus == 'completed'"
                                            (click)="viewanalysis(mock, mock.attemptList[0], '0')"
                                            style="background-color: #fff;border:1px solid #fff;color:#000;margin-right:0"
                                            mat-flat-button color="primary">
                                            <span><img
                                                    src="https://media.iquanta.in/ui_images/rocket.png"></span>View
                                            Analysis</button>
                                    </div>
                                </div>
                                <div *ngIf="!token || !mock.attemptAllowed">
                                    <div class="career_btn d-flex align-items-end">
                                        <button (click)="startMock(mock)"
                                            style="background-color: #fff;border:1px solid #fff;color:#000;margin-right:0"
                                            mat-flat-button color="primary">
                                            <span><img
                                                    src="https://media.iquanta.in/ui_images/rocket.png"></span>Start
                                            Mock</button>
                                    </div>
                                </div>
                            </div>
                            <div class="desk-none">
                                <div class="career_btn d-flex align-items-end">
                                    <button style="background-color: #fff;border:1px solid #fff;
                                            color:#000;margin-right:0;    line-height: initial;
                                            padding: 0;height:auto;
                                            " mat-flat-button color="primary">
                                        Attempt From Desktop</button>
                                </div>
                            </div>
                        </ng-container>
                        <ng-template #paidBtn>
                            <div class="career_btn d-flex align-items-start">
                                <button *ngIf="mock.paid"
                                    style="background-color: #f44336;border:1px solid #f44336"
                                    (click)="goto('packages')" mat-flat-button color="primary">Paid</button>
    
                                <button [matTooltip]="'This free mock will be available from '+mock.launch"
                                    *ngIf="!mock.paid" #myTooltip="matTooltip" (click)="displayTooltip()"
                                    style="background-color: #11830d;border:1px solid #11830d" mat-flat-button
                                    color="primary">Purchased</button>
    
                                <button *ngIf="mock.lock" class="mobile-none"
                                    style="background-color: #fff;border:1px solid #fff;color:#000;margin-right:0"
                                    mat-flat-button color="primary">
                                    <i class="bi bi-lock-fill"></i> Locked</button>
                                <ng-container *ngIf="mock.lock">
                                    <button class="desk-none"
                                        style="background-color: #fff;border:1px solid #fff;color:#000;margin-right:0"
                                        mat-flat-button color="primary">
                                        <i class="bi bi-lock-fill"></i> </button>
                                </ng-container>
                            </div>
                        </ng-template>
    
                    </li>
    
    
    
                </ul>
                <ul *ngIf="tabVal == 'IndoreVA'">
                    <li class="d-flex justify-content-between" *ngFor="let mock of IndoreVA">
                        <div class="caree_title d-flex">
                            <h3>{{mock.name}}</h3>
                            <p *ngIf="!mock.launch" style="color: #f44336">Live Now</p>
                            <p *ngIf="mock.launch">Start Date {{mock.launch}}</p>
                        </div>
                        <ng-container *ngIf="!mock.launch && !mock.paid; else paidBtn">
                            <div class="mobile-none">
                                <div *ngIf="mock.attemptAllowed > 1">
                                    <div class="career_btn d-flex align-items-end">
    
                                        <div *ngFor="let attempt of mock.attemptList; let i = index">
                                            <div>
                                                <p *ngIf="attempt.mockStatus == 'paused' || attempt.mockStatus == 'resumed' || (attempt.mockStatus == 'started' && attempt.attemptId)"
                                                    style="color: #ffffff !important;
                                                text-align: center;
                                                margin-bottom: 10px;
                                                font-size: 14px;">Attempt {{i+1}}</p>
                                                <button
                                                    *ngIf="attempt.mockStatus == 'paused' || attempt.mockStatus == 'resumed' || (attempt.mockStatus == 'started' && attempt.attemptId)"
                                                    (click)="resume(mock, attempt, i)"
                                                    style="background-color: #fff;border:1px solid #fff;color:#000;margin-right:5px"
                                                    mat-flat-button color="primary">
                                                    <img src="https://media.iquanta.in/ui_images/rocket.png"
                                                        alt=""
                                                        style="width: 15px; margin-right: 10px;">Resume</button>
                                            </div>
    
                                            <p *ngIf="attempt.mockStatus == 'completed'" style="color: #ffffff !important;
                                          text-align: center;
                                          margin-bottom: 10px;
                                          font-size: 14px;">Attempt {{i+1}}</p>
                                            <button *ngIf="attempt.mockStatus == 'completed'"
                                                (click)="viewanalysis(mock, attempt, i)"
                                                style="background-color: #fff;border:1px solid #fff;color:#000;margin-right:5px"
                                                mat-flat-button color="primary">
                                                View
                                                Analysis</button>
                                        </div>
    
                                        <div *ngIf="mock.attemptAllowed && mock.attemptAllowed > mock?.attemptList?.length &&
                                            (mock.attemptList[mock.attemptList.length - 1].mockStatus == 'completed' 
                                            || !mock.attemptList[mock.attemptList.length - 1].mockStatus ) || (mock.attemptList[mock.attemptList.length - 1].mockStatus == 'started' &&
                                            !mock.attemptList[mock.attemptList.length - 1].attemptId)  ">
                                            <button
                                                *ngIf="!mock.attemptList[mock.attemptList.length - 1].attemptId"
                                                (click)="startMock(mock)"
                                                style="background-color: #fff;border:1px solid #fff;color:#000;margin-right:0"
                                                mat-flat-button color="primary">
                                                <span><img
                                                        src="https://media.iquanta.in/ui_images/rocket.png"></span>Start
                                                Mock</button>
                                            <button
                                                *ngIf="mock.attemptList[mock.attemptList.length - 1].attemptId"
                                                (click)="startMock(mock)"
                                                style="background-color: #ffe401;border:1px solid #ffe401;color:#000;margin-right:0"
                                                mat-flat-button color="primary">
                                                <span><img
                                                        src="https://media.iquanta.in/ui_images/rocket.png"></span>Reattempt</button>
                                        </div>
    
                                    </div>
                                </div>
                                <div *ngIf="mock.attemptAllowed == 1">
                                    <div class="career_btn d-flex align-items-end">
                                        <button *ngIf="!mock.attemptList[0].attemptId" (click)="startMock(mock)"
                                            style="background-color: #fff;border:1px solid #fff;color:#000;margin-right:0"
                                            mat-flat-button color="primary">
                                            <span><img
                                                    src="https://media.iquanta.in/ui_images/rocket.png"></span>Start
                                            Mock</button>
    
                                        <button
                                            *ngIf="mock.attemptList[0].mockStatus == 'paused' || mock.attemptList[0].mockStatus == 'resumed' || mock.attemptList[0].mockStatus == 'started'"
                                            (click)="resume(mock, mock.attemptList[0], '0')"
                                            style="background-color: #fff;border:1px solid #fff;color:#000;margin-right:0"
                                            mat-flat-button color="primary">
                                            <span><img
                                                    src="https://media.iquanta.in/ui_images/rocket.png"></span>Resume</button>
    
                                        <button *ngIf="mock.attemptList[0].mockStatus == 'completed'"
                                            (click)="viewanalysis(mock, mock.attemptList[0], '0')"
                                            style="background-color: #fff;border:1px solid #fff;color:#000;margin-right:0"
                                            mat-flat-button color="primary">
                                            <span><img
                                                    src="https://media.iquanta.in/ui_images/rocket.png"></span>View
                                            Analysis</button>
                                    </div>
                                </div>
                                <div *ngIf="!token || !mock.attemptAllowed">
                                    <div class="career_btn d-flex align-items-end">
                                        <button (click)="startMock(mock)"
                                            style="background-color: #fff;border:1px solid #fff;color:#000;margin-right:0"
                                            mat-flat-button color="primary">
                                            <span><img
                                                    src="https://media.iquanta.in/ui_images/rocket.png"></span>Start
                                            Mock</button>
                                    </div>
                                </div>
                            </div>
                            <div class="desk-none">
                                <div class="career_btn d-flex align-items-end">
                                    <button style="background-color: #fff;border:1px solid #fff;
                                            color:#000;margin-right:0;    line-height: initial;
                                            padding: 0;height:auto;
                                            " mat-flat-button color="primary">
                                        Attempt From Desktop</button>
                                </div>
                            </div>
                        </ng-container>
                        <ng-template #paidBtn>
                            <div class="career_btn d-flex align-items-start">
                                <button *ngIf="mock.paid"
                                    style="background-color: #f44336;border:1px solid #f44336"
                                    (click)="goto('packages')" mat-flat-button color="primary">Paid</button>
    
                                <button [matTooltip]="'This free mock will be available from '+mock.launch"
                                    *ngIf="!mock.paid" #myTooltip="matTooltip" (click)="displayTooltip()"
                                    style="background-color: #11830d;border:1px solid #11830d" mat-flat-button
                                    color="primary">Purchased</button>
    
                                <button *ngIf="mock.lock" class="mobile-none"
                                    style="background-color: #fff;border:1px solid #fff;color:#000;margin-right:0"
                                    mat-flat-button color="primary">
                                    <i class="bi bi-lock-fill"></i> Locked</button>
                                <ng-container *ngIf="mock.lock">
                                    <button class="desk-none"
                                        style="background-color: #fff;border:1px solid #fff;color:#000;margin-right:0"
                                        mat-flat-button color="primary">
                                        <i class="bi bi-lock-fill"></i> </button>
                                </ng-container>
                            </div>
                        </ng-template>
    
                    </li>
    
    
    
                </ul>    
                <ul *ngIf="tabVal == 'pastpapers'">
                    <li class="d-flex justify-content-between" *ngFor="let mock of pastPapers">
                        <div class="caree_title d-flex">
                            <h3>{{mock.name}}</h3>
                            <p *ngIf="!mock.launch" style="color: #f44336">Live Now</p>
                            <p *ngIf="mock.launch">Start Date {{mock.launch}}</p>
                        </div>
                        <ng-container *ngIf="!mock.launch && !mock.paid; else paidBtn">
                            <div class="mobile-none">
                                <div *ngIf="mock.attemptAllowed > 1">
                                    <div class="career_btn d-flex align-items-end">
    
                                        <div *ngFor="let attempt of mock.attemptList; let i = index">
                                            <div>
                                                <p *ngIf="attempt.mockStatus == 'paused' || attempt.mockStatus == 'resumed' || (attempt.mockStatus == 'started' && attempt.attemptId)"
                                                    style="color: #ffffff !important;
                                                text-align: center;
                                                margin-bottom: 10px;
                                                font-size: 14px;">Attempt {{i+1}}</p>
                                                <button
                                                    *ngIf="attempt.mockStatus == 'paused' || attempt.mockStatus == 'resumed' || (attempt.mockStatus == 'started' && attempt.attemptId)"
                                                    (click)="resume(mock, attempt, i)"
                                                    style="background-color: #fff;border:1px solid #fff;color:#000;margin-right:5px"
                                                    mat-flat-button color="primary">
                                                    <img src="https://media.iquanta.in/ui_images/rocket.png"
                                                        alt=""
                                                        style="width: 15px; margin-right: 10px;">Resume</button>
                                            </div>
    
                                            <p *ngIf="attempt.mockStatus == 'completed'" style="color: #ffffff !important;
                                          text-align: center;
                                          margin-bottom: 10px;
                                          font-size: 14px;">Attempt {{i+1}}</p>
                                            <button *ngIf="attempt.mockStatus == 'completed'"
                                                (click)="viewanalysis(mock, attempt, i)"
                                                style="background-color: #fff;border:1px solid #fff;color:#000;margin-right:5px"
                                                mat-flat-button color="primary">
                                                View
                                                Analysis</button>
                                        </div>
    
                                        <div *ngIf="mock.attemptAllowed && mock.attemptAllowed > mock?.attemptList?.length &&
                                            (mock.attemptList[mock.attemptList.length - 1].mockStatus == 'completed' 
                                            || !mock.attemptList[mock.attemptList.length - 1].mockStatus ) || (mock.attemptList[mock.attemptList.length - 1].mockStatus == 'started' &&
                                            !mock.attemptList[mock.attemptList.length - 1].attemptId)  ">
                                            <button
                                                *ngIf="!mock.attemptList[mock.attemptList.length - 1].attemptId"
                                                (click)="startMock(mock)"
                                                style="background-color: #fff;border:1px solid #fff;color:#000;margin-right:0"
                                                mat-flat-button color="primary">
                                                <span><img
                                                        src="https://media.iquanta.in/ui_images/rocket.png"></span>Start
                                                Mock</button>
                                            <button
                                                *ngIf="mock.attemptList[mock.attemptList.length - 1].attemptId"
                                                (click)="startMock(mock)"
                                                style="background-color: #ffe401;border:1px solid #ffe401;color:#000;margin-right:0"
                                                mat-flat-button color="primary">
                                                <span><img
                                                        src="https://media.iquanta.in/ui_images/rocket.png"></span>Reattempt</button>
                                        </div>
    
                                    </div>
                                </div>
                                <div *ngIf="mock.attemptAllowed == 1">
                                    <div class="career_btn d-flex align-items-end">
                                        <button *ngIf="!mock.attemptList[0].attemptId" (click)="startMock(mock)"
                                            style="background-color: #fff;border:1px solid #fff;color:#000;margin-right:0"
                                            mat-flat-button color="primary">
                                            <span><img
                                                    src="https://media.iquanta.in/ui_images/rocket.png"></span>Start
                                            Mock</button>
    
                                        <button
                                            *ngIf="mock.attemptList[0].mockStatus == 'paused' || mock.attemptList[0].mockStatus == 'resumed' || mock.attemptList[0].mockStatus == 'started'"
                                            (click)="resume(mock, mock.attemptList[0], '0')"
                                            style="background-color: #fff;border:1px solid #fff;color:#000;margin-right:0"
                                            mat-flat-button color="primary">
                                            <span><img
                                                    src="https://media.iquanta.in/ui_images/rocket.png"></span>Resume</button>
    
                                        <button *ngIf="mock.attemptList[0].mockStatus == 'completed'"
                                            (click)="viewanalysis(mock, mock.attemptList[0], '0')"
                                            style="background-color: #fff;border:1px solid #fff;color:#000;margin-right:0"
                                            mat-flat-button color="primary">
                                            <span><img
                                                    src="https://media.iquanta.in/ui_images/rocket.png"></span>View
                                            Analysis</button>
                                    </div>
                                </div>
                                <div *ngIf="!token || !mock.attemptAllowed">
                                    <div class="career_btn d-flex align-items-end">
                                        <button (click)="startMock(mock)"
                                            style="background-color: #fff;border:1px solid #fff;color:#000;margin-right:0"
                                            mat-flat-button color="primary">
                                            <span><img
                                                    src="https://media.iquanta.in/ui_images/rocket.png"></span>Start
                                            Mock</button>
                                    </div>
                                </div>
                            </div>
                            <div class="desk-none">
                                <div class="career_btn d-flex align-items-end">
                                    <button style="background-color: #fff;border:1px solid #fff;
                                            color:#000;margin-right:0;    line-height: initial;
                                            padding: 0;height:auto;
                                            " mat-flat-button color="primary">
                                        Attempt From Desktop</button>
                                </div>
                            </div>
                        </ng-container>
                        <ng-template #paidBtn>
                            <div class="career_btn d-flex align-items-start">
                                <button *ngIf="mock.paid"
                                    style="background-color: #f44336;border:1px solid #f44336"
                                    (click)="goto('packages')" mat-flat-button color="primary">Paid</button>
    
                                <button [matTooltip]="'This free mock will be available from '+mock.launch"
                                    *ngIf="!mock.paid" #myTooltip="matTooltip" (click)="displayTooltip()"
                                    style="background-color: #11830d;border:1px solid #11830d" mat-flat-button
                                    color="primary">Purchased</button>
    
                                <button *ngIf="mock.lock" class="mobile-none"
                                    style="background-color: #fff;border:1px solid #fff;color:#000;margin-right:0"
                                    mat-flat-button color="primary">
                                    <i class="bi bi-lock-fill"></i> Locked</button>
                                <ng-container *ngIf="mock.lock">
                                    <button class="desk-none"
                                        style="background-color: #fff;border:1px solid #fff;color:#000;margin-right:0"
                                        mat-flat-button color="primary">
                                        <i class="bi bi-lock-fill"></i> </button>
                                </ng-container>
                            </div>
                        </ng-template>
    
                    </li>
    
    
    
                </ul>
                <ul *ngIf="tabVal == 'iim'">
                    <li class="d-flex justify-content-between" *ngFor="let mock of iim">
                        <div class="caree_title d-flex">
                            <h3>{{mock.name}}</h3>
                            <p *ngIf="!mock.launch" style="color: #f44336">Live Now</p>
                            <p *ngIf="mock.launch">Start Date {{mock.launch}}</p>
                        </div>
                        <ng-container *ngIf="!mock.launch && !mock.paid; else paidBtn">
                            <div class="mobile-none">
                                <div *ngIf="mock.attemptAllowed > 1">
                                    <div class="career_btn d-flex align-items-end">
    
                                        <div *ngFor="let attempt of mock.attemptList; let i = index">
                                            <div>
                                                <p *ngIf="attempt.mockStatus == 'paused' || attempt.mockStatus == 'resumed' || (attempt.mockStatus == 'started' && attempt.attemptId)"
                                                    style="color: #ffffff !important;
                                                text-align: center;
                                                margin-bottom: 10px;
                                                font-size: 14px;">Attempt {{i+1}}</p>
                                                <button
                                                    *ngIf="attempt.mockStatus == 'paused' || attempt.mockStatus == 'resumed' || (attempt.mockStatus == 'started' && attempt.attemptId)"
                                                    (click)="resume(mock, attempt, i)"
                                                    style="background-color: #fff;border:1px solid #fff;color:#000;margin-right:5px"
                                                    mat-flat-button color="primary">
                                                    <img src="https://media.iquanta.in/ui_images/rocket.png"
                                                        alt=""
                                                        style="width: 15px; margin-right: 10px;">Resume</button>
                                            </div>
    
                                            <p *ngIf="attempt.mockStatus == 'completed'" style="color: #ffffff !important;
                                          text-align: center;
                                          margin-bottom: 10px;
                                          font-size: 14px;">Attempt {{i+1}}</p>
                                            <button *ngIf="attempt.mockStatus == 'completed'"
                                                (click)="viewanalysis(mock, attempt, i)"
                                                style="background-color: #fff;border:1px solid #fff;color:#000;margin-right:5px"
                                                mat-flat-button color="primary">
                                                View
                                                Analysis</button>
                                        </div>
    
                                        <div *ngIf="mock.attemptAllowed && mock.attemptAllowed > mock?.attemptList?.length &&
                                            (mock.attemptList[mock.attemptList.length - 1].mockStatus == 'completed' 
                                            || !mock.attemptList[mock.attemptList.length - 1].mockStatus ) || (mock.attemptList[mock.attemptList.length - 1].mockStatus == 'started' &&
                                            !mock.attemptList[mock.attemptList.length - 1].attemptId)  ">
                                            <button
                                                *ngIf="!mock.attemptList[mock.attemptList.length - 1].attemptId"
                                                (click)="startMock(mock)"
                                                style="background-color: #fff;border:1px solid #fff;color:#000;margin-right:0"
                                                mat-flat-button color="primary">
                                                <span><img
                                                        src="https://media.iquanta.in/ui_images/rocket.png"></span>Start
                                                Mock</button>
                                            <button
                                                *ngIf="mock.attemptList[mock.attemptList.length - 1].attemptId"
                                                (click)="startMock(mock)"
                                                style="background-color: #ffe401;border:1px solid #ffe401;color:#000;margin-right:0"
                                                mat-flat-button color="primary">
                                                <span><img
                                                        src="https://media.iquanta.in/ui_images/rocket.png"></span>Reattempt</button>
                                        </div>
    
                                    </div>
                                </div>
                                <div *ngIf="mock.attemptAllowed == 1">
                                    <div class="career_btn d-flex align-items-end">
                                        <button *ngIf="!mock.attemptList[0].attemptId" (click)="startMock(mock)"
                                            style="background-color: #fff;border:1px solid #fff;color:#000;margin-right:0"
                                            mat-flat-button color="primary">
                                            <span><img
                                                    src="https://media.iquanta.in/ui_images/rocket.png"></span>Start
                                            Mock</button>
    
                                        <button
                                            *ngIf="mock.attemptList[0].mockStatus == 'paused' || mock.attemptList[0].mockStatus == 'resumed' || mock.attemptList[0].mockStatus == 'started'"
                                            (click)="resume(mock, mock.attemptList[0], '0')"
                                            style="background-color: #fff;border:1px solid #fff;color:#000;margin-right:0"
                                            mat-flat-button color="primary">
                                            <span><img
                                                    src="https://media.iquanta.in/ui_images/rocket.png"></span>Resume</button>
    
                                        <button *ngIf="mock.attemptList[0].mockStatus == 'completed'"
                                            (click)="viewanalysis(mock, mock.attemptList[0], '0')"
                                            style="background-color: #fff;border:1px solid #fff;color:#000;margin-right:0"
                                            mat-flat-button color="primary">
                                            <span><img
                                                    src="https://media.iquanta.in/ui_images/rocket.png"></span>View
                                            Analysis</button>
                                    </div>
                                </div>
                                <div *ngIf="!token || !mock.attemptAllowed">
                                    <div class="career_btn d-flex align-items-end">
                                        <button (click)="startMock(mock)"
                                            style="background-color: #fff;border:1px solid #fff;color:#000;margin-right:0"
                                            mat-flat-button color="primary">
                                            <span><img
                                                    src="https://media.iquanta.in/ui_images/rocket.png"></span>Start
                                            Mock</button>
                                    </div>
                                </div>
                            </div>
                            <div class="desk-none">
                                <div class="career_btn d-flex align-items-end">
                                    <button style="background-color: #fff;border:1px solid #fff;
                                            color:#000;margin-right:0;    line-height: initial;
                                            padding: 0;height:auto;
                                            " mat-flat-button color="primary">
                                        Attempt From Desktop</button>
                                </div>
                            </div>
                        </ng-container>
                        <ng-template #paidBtn>
                            <div class="career_btn d-flex align-items-start">
                                <button *ngIf="mock.paid"
                                    style="background-color: #f44336;border:1px solid #f44336"
                                    (click)="goto('packages')" mat-flat-button color="primary">Paid</button>
    
                                <button [matTooltip]="'This free mock will be available from '+mock.launch"
                                    *ngIf="!mock.paid" #myTooltip="matTooltip" (click)="displayTooltip()"
                                    style="background-color: #11830d;border:1px solid #11830d" mat-flat-button
                                    color="primary">Purchased</button>
    
                                <button *ngIf="mock.lock" class="mobile-none"
                                    style="background-color: #fff;border:1px solid #fff;color:#000;margin-right:0"
                                    mat-flat-button color="primary">
                                    <i class="bi bi-lock-fill"></i> Locked</button>
                                <ng-container *ngIf="mock.lock">
                                    <button class="desk-none"
                                        style="background-color: #fff;border:1px solid #fff;color:#000;margin-right:0"
                                        mat-flat-button color="primary">
                                        <i class="bi bi-lock-fill"></i> </button>
                                </ng-container>
                            </div>
                        </ng-template>
    
                    </li>
    
    
    
                </ul>
    
    
                <ul *ngIf="tabVal == 'full'">
                    <li class="d-flex justify-content-between"
                        *ngFor="let mock of fullmockDetailList.slice(0, loadmore1)">
                        <div class="caree_title d-flex">
                            <h3>{{mock.name}}</h3>
                            <p *ngIf="!mock.launch" style="color: #f44336">Live Now: <span
                                    style="color: #00ff80">Analysis & Solutions available after
                                    Submission</span></p>
                            <p *ngIf="mock.launch">Start Date {{mock.launch}}</p>
                        </div>
    
                        <ng-container *ngIf="!mock.launch && !mock.paid; else paidBtn">
                            <div class="mobile-none">
                                <div *ngIf="mock.attemptAllowed > 1">
                                    <div class="career_btn d-flex align-items-end">
    
                                        <div *ngFor="let attempt of mock.attemptList; let i = index">
                                            <div>
                                                <p *ngIf="attempt.mockStatus == 'paused' || attempt.mockStatus == 'resumed' || (attempt.mockStatus == 'started' && attempt.attemptId)"
                                                    style="color: #ffffff !important;
                                                text-align: center;
                                                margin-bottom: 10px;
                                                font-size: 14px;">Attempt {{i+1}}</p>
                                                <button
                                                    *ngIf="attempt.mockStatus == 'paused' || attempt.mockStatus == 'resumed' || (attempt.mockStatus == 'started' && attempt.attemptId)"
                                                    (click)="resume(mock, attempt, i)"
                                                    style="background-color: #fff;border:1px solid #fff;color:#000;margin-right:5px"
                                                    mat-flat-button color="primary">
                                                    <img src="https://media.iquanta.in/ui_images/rocket.png"
                                                        alt=""
                                                        style="width: 15px; margin-right: 10px;">Resume</button>
                                            </div>
    
                                            <p *ngIf="attempt.mockStatus == 'completed'" style="color: #ffffff !important;
                                          text-align: center;
                                          margin-bottom: 10px;
                                          font-size: 14px;">Attempt {{i+1}}</p>
                                            <button *ngIf="attempt.mockStatus == 'completed'"
                                                (click)="viewanalysis(mock, attempt, i)"
                                                style="background-color: #fff;border:1px solid #fff;color:#000;margin-right:5px"
                                                mat-flat-button color="primary">
                                                View
                                                Analysis</button>
                                        </div>
    
                                        <div *ngIf="mock.attemptAllowed && mock.attemptAllowed > mock?.attemptList?.length &&
                                            (mock.attemptList[mock.attemptList.length - 1].mockStatus == 'completed' 
                                            || !mock.attemptList[mock.attemptList.length - 1].mockStatus ) || (mock.attemptList[mock.attemptList.length - 1].mockStatus == 'started' &&
                                            !mock.attemptList[mock.attemptList.length - 1].attemptId)  ">
                                            <button
                                                *ngIf="!mock.attemptList[mock.attemptList.length - 1].attemptId"
                                                (click)="startMock(mock)"
                                                style="background-color: #fff;border:1px solid #fff;color:#000;margin-right:0"
                                                mat-flat-button color="primary">
                                                <span><img
                                                        src="https://media.iquanta.in/ui_images/rocket.png"></span>Start
                                                Mock</button>
                                            <button
                                                *ngIf="mock.attemptList[mock.attemptList.length - 1].attemptId"
                                                (click)="startMock(mock)"
                                                style="background-color: #ffe401;border:1px solid #ffe401;color:#000;margin-right:0"
                                                mat-flat-button color="primary">
                                                <span><img
                                                        src="https://media.iquanta.in/ui_images/rocket.png"></span>Reattempt</button>
                                        </div>
    
                                    </div>
                                </div>
                                <div *ngIf="mock.attemptAllowed == 1">
                                    <div class="career_btn d-flex align-items-end">
                                        <button *ngIf="!mock.attemptList[0].attemptId" (click)="startMock(mock)"
                                            style="background-color: #fff;border:1px solid #fff;color:#000;margin-right:0"
                                            mat-flat-button color="primary">
                                            <span><img
                                                    src="https://media.iquanta.in/ui_images/rocket.png"></span>Start
                                            Mock</button>
    
                                        <button
                                            *ngIf="mock.attemptList[0].mockStatus == 'paused' || mock.attemptList[0].mockStatus == 'resumed' || mock.attemptList[0].mockStatus == 'started'"
                                            (click)="resume(mock, mock.attemptList[0], '0')"
                                            style="background-color: #fff;border:1px solid #fff;color:#000;margin-right:0"
                                            mat-flat-button color="primary">
                                            <span><img
                                                    src="https://media.iquanta.in/ui_images/rocket.png"></span>Resume</button>
    
                                        <button *ngIf="mock.attemptList[0].mockStatus == 'completed'"
                                            (click)="viewanalysis(mock, mock.attemptList[0], '0')"
                                            style="background-color: #fff;border:1px solid #fff;color:#000;margin-right:0"
                                            mat-flat-button color="primary">
                                            <span><img
                                                    src="https://media.iquanta.in/ui_images/rocket.png"></span>View
                                            Analysis</button>
                                    </div>
                                </div>
                                <div *ngIf="!token || !mock.attemptAllowed">
                                    <div class="career_btn d-flex align-items-end">
                                        <button (click)="startMock(mock)"
                                            style="background-color: #fff;border:1px solid #fff;color:#000;margin-right:0"
                                            mat-flat-button color="primary">
                                            <span><img
                                                    src="https://media.iquanta.in/ui_images/rocket.png"></span>Start
                                            Mock</button>
                                    </div>
                                </div>
                            </div>
    
                            <div class="desk-none">
                                <div class="career_btn d-flex align-items-end">
                                    <button style="background-color: #fff;border:1px solid #fff;
                                            color:#000;margin-right:0;    line-height: initial;
    padding: 0;height:auto;
    " mat-flat-button color="primary">
                                        Attempt From Desktop</button>
                                </div>
                            </div>
    
                        </ng-container>
    
                        <ng-template #paidBtn>
                            <div class="career_btn d-flex align-items-start">
                                <button *ngIf="mock.paid"
                                    style="background-color: #f44336;border:1px solid #f44336"
                                    (click)="goto('packages')" mat-flat-button color="primary">Paid</button>
    
                                <button [matTooltip]="'This free mock will be available from '+mock.launch"
                                    *ngIf="!mock.paid" #myTooltip="matTooltip" (click)="displayTooltip()"
                                    style="background-color: #11830d;border:1px solid #11830d" mat-flat-button
                                    color="primary">Purchased</button>
    
                                <button *ngIf="mock.lock" class="mobile-none"
                                    style="background-color: #fff;border:1px solid #fff;color:#000;margin-right:0"
                                    mat-flat-button color="primary">
                                    <i class="bi bi-lock-fill"></i> Locked</button>
    
    
                                <ng-container *ngIf="mock.lock">
                                    <button class="desk-none"
                                        style="background-color: #fff;border:1px solid #fff;color:#000;margin-right:0"
                                        mat-flat-button color="primary">
                                        <i class="bi bi-lock-fill"></i> </button>
                                </ng-container>
    
    
                            </div>
                        </ng-template>
    
                    </li>
    
    
    
                </ul>
    
                <ul *ngIf="tabVal == 'sectional'">
                    <ng-container *ngIf="tabVal1 == 'quant'">
                        <li class="d-flex justify-content-between"
                            *ngFor="let mock of quantMockList.slice(0, loadmore2)">
                            <div class="caree_title d-flex">
                                <h3>{{mock.name}}</h3>
                                <p *ngIf="!mock.launch" style="color: #f44336">Live Now</p>
                                <p *ngIf="mock.launch">Start Date {{mock.launch}}</p>
                            </div>
    
                            <ng-container *ngIf="!mock.launch && !mock.paid; else paidBtn1">
                                <div class="mobile-none">
                                    <div *ngIf="mock.attemptAllowed > 1">
                                        <div class="career_btn d-flex align-items-end">
        
                                            <div *ngFor="let attempt of mock.attemptList; let i = index">
                                                <div>
                                                    <p *ngIf="attempt.mockStatus == 'paused' || attempt.mockStatus == 'resumed' || (attempt.mockStatus == 'started' && attempt.attemptId)"
                                                        style="color: #ffffff !important;
                                                    text-align: center;
                                                    margin-bottom: 10px;
                                                    font-size: 14px;">Attempt {{i+1}}</p>
                                                    <button
                                                        *ngIf="attempt.mockStatus == 'paused' || attempt.mockStatus == 'resumed' || (attempt.mockStatus == 'started' && attempt.attemptId)"
                                                        (click)="resume(mock, attempt, i)"
                                                        style="background-color: #fff;border:1px solid #fff;color:#000;margin-right:5px"
                                                        mat-flat-button color="primary">
                                                        <img src="https://media.iquanta.in/ui_images/rocket.png"
                                                            alt=""
                                                            style="width: 15px; margin-right: 10px;">Resume</button>
                                                </div>
        
                                                <p *ngIf="attempt.mockStatus == 'completed'" style="color: #ffffff !important;
                                              text-align: center;
                                              margin-bottom: 10px;
                                              font-size: 14px;">Attempt {{i+1}}</p>
                                                <button *ngIf="attempt.mockStatus == 'completed'"
                                                    (click)="viewanalysis(mock, attempt, i)"
                                                    style="background-color: #fff;border:1px solid #fff;color:#000;margin-right:5px"
                                                    mat-flat-button color="primary">
                                                    View
                                                    Analysis</button>
                                            </div>
        
                                            <div *ngIf="mock.attemptAllowed && mock.attemptAllowed > mock?.attemptList?.length &&
                                                (mock.attemptList[mock.attemptList.length - 1].mockStatus == 'completed' 
                                                || !mock.attemptList[mock.attemptList.length - 1].mockStatus ) || (mock.attemptList[mock.attemptList.length - 1].mockStatus == 'started' &&
                                                !mock.attemptList[mock.attemptList.length - 1].attemptId)  ">
                                                <button
                                                    *ngIf="!mock.attemptList[mock.attemptList.length - 1].attemptId"
                                                    (click)="startMock(mock)"
                                                    style="background-color: #fff;border:1px solid #fff;color:#000;margin-right:0"
                                                    mat-flat-button color="primary">
                                                    <span><img
                                                            src="https://media.iquanta.in/ui_images/rocket.png"></span>Start
                                                    Mock</button>
                                                <button
                                                    *ngIf="mock.attemptList[mock.attemptList.length - 1].attemptId"
                                                    (click)="startMock(mock)"
                                                    style="background-color: #ffe401;border:1px solid #ffe401;color:#000;margin-right:0"
                                                    mat-flat-button color="primary">
                                                    <span><img
                                                            src="https://media.iquanta.in/ui_images/rocket.png"></span>Reattempt</button>
                                            </div>
        
                                        </div>
                                    </div>
                                    <div *ngIf="mock.attemptAllowed == 1">
                                        <div class="career_btn d-flex align-items-end">
                                            <button *ngIf="!mock.attemptList[0].attemptId" (click)="startMock(mock)"
                                                style="background-color: #fff;border:1px solid #fff;color:#000;margin-right:0"
                                                mat-flat-button color="primary">
                                                <span><img
                                                        src="https://media.iquanta.in/ui_images/rocket.png"></span>Start
                                                Mock</button>
        
                                            <button
                                                *ngIf="mock.attemptList[0].mockStatus == 'paused' || mock.attemptList[0].mockStatus == 'resumed' || mock.attemptList[0].mockStatus == 'started'"
                                                (click)="resume(mock, mock.attemptList[0], '0')"
                                                style="background-color: #fff;border:1px solid #fff;color:#000;margin-right:0"
                                                mat-flat-button color="primary">
                                                <span><img
                                                        src="https://media.iquanta.in/ui_images/rocket.png"></span>Resume</button>
        
                                            <button *ngIf="mock.attemptList[0].mockStatus == 'completed'"
                                                (click)="viewanalysis(mock, mock.attemptList[0], '0')"
                                                style="background-color: #fff;border:1px solid #fff;color:#000;margin-right:0"
                                                mat-flat-button color="primary">
                                                <span><img
                                                        src="https://media.iquanta.in/ui_images/rocket.png"></span>View
                                                Analysis</button>
                                        </div>
                                    </div>
                                    <div *ngIf="!token || !mock.attemptAllowed">
                                        <div class="career_btn d-flex align-items-end">
                                            <button (click)="startMock(mock)"
                                                style="background-color: #fff;border:1px solid #fff;color:#000;margin-right:0"
                                                mat-flat-button color="primary">
                                                <span><img
                                                        src="https://media.iquanta.in/ui_images/rocket.png"></span>Start
                                                Mock</button>
                                        </div>
                                    </div>
                                </div>
    
                                <div class="desk-none">
                                    <div class="career_btn d-flex align-items-end">
                                        <button style="background-color: #fff;border:1px solid #fff;
                                                color:#000;margin-right:0;    line-height: initial;
    padding: 0;height:auto;
    " mat-flat-button color="primary">
                                            Attempt From Desktop</button>
                                    </div>
                                </div>
                            </ng-container>
    
                            <ng-template #paidBtn1>
                                <div class="career_btn d-flex align-items-start">
                                    <button *ngIf="mock.paid"
                                        style="background-color: #f44336;border:1px solid #f44336"
                                        (click)="goto('packages')" mat-flat-button color="primary">Paid</button>
    
                                    <button [matTooltip]="'This free mock will be available from '+mock.launch"
                                        *ngIf="!mock.paid"
                                        style="background-color: #11830d;border:1px solid #11830d"
                                        mat-flat-button color="primary">Purchased</button>
                                    <button *ngIf="mock.lock" class="mobile-none"
                                        style="background-color: #fff;border:1px solid #fff;color:#000;margin-right:0"
                                        mat-flat-button color="primary">
                                        <i class="bi bi-lock-fill"></i> Locked</button>
    
    
                                    <ng-container *ngIf="mock.lock">
                                        <button class="desk-none"
                                            style="background-color: #fff;border:1px solid #fff;color:#000;margin-right:0"
                                            mat-flat-button color="primary">
                                            <i class="bi bi-lock-fill"></i> </button>
                                    </ng-container>
    
    
                                </div>
                            </ng-template>
    
                        </li>
                    </ng-container>
                    <ng-container *ngIf="tabVal1 == 'varc'">
                        <li class="d-flex justify-content-between"
                            *ngFor="let mock of varcMockList.slice(0, loadmore2)">
                            <div class="caree_title d-flex">
                                <h3>{{mock.name}}</h3>
                                <p *ngIf="!mock.launch" style="color: #f44336">Live Now</p>
                                <p *ngIf="mock.launch">Start Date {{mock.launch}}</p>
                            </div>
    
                            <ng-container *ngIf="!mock.launch && !mock.paid; else paidBtn2">
                                <div class="mobile-none">
                                    <div *ngIf="mock.attemptAllowed > 1">
                                        <div class="career_btn d-flex align-items-end">
        
                                            <div *ngFor="let attempt of mock.attemptList; let i = index">
                                                <div>
                                                    <p *ngIf="attempt.mockStatus == 'paused' || attempt.mockStatus == 'resumed' || (attempt.mockStatus == 'started' && attempt.attemptId)"
                                                        style="color: #ffffff !important;
                                                    text-align: center;
                                                    margin-bottom: 10px;
                                                    font-size: 14px;">Attempt {{i+1}}</p>
                                                    <button
                                                        *ngIf="attempt.mockStatus == 'paused' || attempt.mockStatus == 'resumed' || (attempt.mockStatus == 'started' && attempt.attemptId)"
                                                        (click)="resume(mock, attempt, i)"
                                                        style="background-color: #fff;border:1px solid #fff;color:#000;margin-right:5px"
                                                        mat-flat-button color="primary">
                                                        <img src="https://media.iquanta.in/ui_images/rocket.png"
                                                            alt=""
                                                            style="width: 15px; margin-right: 10px;">Resume</button>
                                                </div>
        
                                                <p *ngIf="attempt.mockStatus == 'completed'" style="color: #ffffff !important;
                                              text-align: center;
                                              margin-bottom: 10px;
                                              font-size: 14px;">Attempt {{i+1}}</p>
                                                <button *ngIf="attempt.mockStatus == 'completed'"
                                                    (click)="viewanalysis(mock, attempt, i)"
                                                    style="background-color: #fff;border:1px solid #fff;color:#000;margin-right:5px"
                                                    mat-flat-button color="primary">
                                                    View
                                                    Analysis</button>
                                            </div>
        
                                            <div *ngIf="mock.attemptAllowed && mock.attemptAllowed > mock?.attemptList?.length &&
                                                (mock.attemptList[mock.attemptList.length - 1].mockStatus == 'completed' 
                                                || !mock.attemptList[mock.attemptList.length - 1].mockStatus ) || (mock.attemptList[mock.attemptList.length - 1].mockStatus == 'started' &&
                                                !mock.attemptList[mock.attemptList.length - 1].attemptId)  ">
                                                <button
                                                    *ngIf="!mock.attemptList[mock.attemptList.length - 1].attemptId"
                                                    (click)="startMock(mock)"
                                                    style="background-color: #fff;border:1px solid #fff;color:#000;margin-right:0"
                                                    mat-flat-button color="primary">
                                                    <span><img
                                                            src="https://media.iquanta.in/ui_images/rocket.png"></span>Start
                                                    Mock</button>
                                                <button
                                                    *ngIf="mock.attemptList[mock.attemptList.length - 1].attemptId"
                                                    (click)="startMock(mock)"
                                                    style="background-color: #ffe401;border:1px solid #ffe401;color:#000;margin-right:0"
                                                    mat-flat-button color="primary">
                                                    <span><img
                                                            src="https://media.iquanta.in/ui_images/rocket.png"></span>Reattempt</button>
                                            </div>
        
                                        </div>
                                    </div>
                                    <div *ngIf="mock.attemptAllowed == 1">
                                        <div class="career_btn d-flex align-items-end">
                                            <button *ngIf="!mock.attemptList[0].attemptId" (click)="startMock(mock)"
                                                style="background-color: #fff;border:1px solid #fff;color:#000;margin-right:0"
                                                mat-flat-button color="primary">
                                                <span><img
                                                        src="https://media.iquanta.in/ui_images/rocket.png"></span>Start
                                                Mock</button>
        
                                            <button
                                                *ngIf="mock.attemptList[0].mockStatus == 'paused' || mock.attemptList[0].mockStatus == 'resumed' || mock.attemptList[0].mockStatus == 'started'"
                                                (click)="resume(mock, mock.attemptList[0], '0')"
                                                style="background-color: #fff;border:1px solid #fff;color:#000;margin-right:0"
                                                mat-flat-button color="primary">
                                                <span><img
                                                        src="https://media.iquanta.in/ui_images/rocket.png"></span>Resume</button>
        
                                            <button *ngIf="mock.attemptList[0].mockStatus == 'completed'"
                                                (click)="viewanalysis(mock, mock.attemptList[0], '0')"
                                                style="background-color: #fff;border:1px solid #fff;color:#000;margin-right:0"
                                                mat-flat-button color="primary">
                                                <span><img
                                                        src="https://media.iquanta.in/ui_images/rocket.png"></span>View
                                                Analysis</button>
                                        </div>
                                    </div>
                                    <div *ngIf="!token || !mock.attemptAllowed">
                                        <div class="career_btn d-flex align-items-end">
                                            <button (click)="startMock(mock)"
                                                style="background-color: #fff;border:1px solid #fff;color:#000;margin-right:0"
                                                mat-flat-button color="primary">
                                                <span><img
                                                        src="https://media.iquanta.in/ui_images/rocket.png"></span>Start
                                                Mock</button>
                                        </div>
                                    </div>
                                </div>
    
                                <div class="desk-none">
                                    <div class="career_btn d-flex align-items-end">
                                        <button style="background-color: #fff;border:1px solid #fff;color:#000;
                                                margin-right:0;    line-height: initial;
                                                padding: 0;height:auto;
                                                " mat-flat-button color="primary">
                                                Attempt From Desktop</button>
                                    </div>
                                </div>
                            </ng-container>
    
                            <ng-template #paidBtn2>
                                <div class="career_btn d-flex align-items-start">
                                    <button *ngIf="mock.paid"
                                        style="background-color: #f44336;border:1px solid #f44336"
                                        (click)="goto('packages')" mat-flat-button color="primary">Paid</button>
    
                                    <button [matTooltip]="'This free mock will be available from '+mock.launch"
                                        *ngIf="!mock.paid"
                                        style="background-color: #11830d;border:1px solid #11830d"
                                        mat-flat-button color="primary">Purchased</button>
    
                                    <button *ngIf="mock.lock" class="mobile-none"
                                        style="background-color: #fff;border:1px solid #fff;color:#000;margin-right:0"
                                        mat-flat-button color="primary">
                                        <i class="bi bi-lock-fill"></i> Locked</button>
    
                                    <ng-container *ngIf="mock.lock">
                                        <button class="desk-none"
                                            style="background-color: #fff;border:1px solid #fff;color:#000;margin-right:0"
                                            mat-flat-button color="primary">
                                            <i class="bi bi-lock-fill"></i> </button>
                                    </ng-container>
    
    
                                </div>
                            </ng-template>
    
                        </li>
                    </ng-container>
                    <ng-container *ngIf="tabVal1 == 'lrdi'">
                        <li class="d-flex justify-content-between"
                            *ngFor="let mock of lrdiMockList.slice(0, loadmore2)">
                            <div class="caree_title d-flex">
                                <h3>{{mock.name}}</h3>
                                <p *ngIf="!mock.launch" style="color: #f44336">Live Now</p>
                                <p *ngIf="mock.launch">Start Date {{mock.launch}}</p>
                            </div>
    
                            <ng-container *ngIf="!mock.launch && !mock.paid; else paidBtn3">
                                <div class="mobile-none">
                                    <div *ngIf="mock.attemptAllowed > 1">
                                        <div class="career_btn d-flex align-items-end">
        
                                            <div *ngFor="let attempt of mock.attemptList; let i = index">
                                                <div>
                                                    <p *ngIf="attempt.mockStatus == 'paused' || attempt.mockStatus == 'resumed' || (attempt.mockStatus == 'started' && attempt.attemptId)"
                                                        style="color: #ffffff !important;
                                                    text-align: center;
                                                    margin-bottom: 10px;
                                                    font-size: 14px;">Attempt {{i+1}}</p>
                                                    <button
                                                        *ngIf="attempt.mockStatus == 'paused' || attempt.mockStatus == 'resumed' || (attempt.mockStatus == 'started' && attempt.attemptId)"
                                                        (click)="resume(mock, attempt, i)"
                                                        style="background-color: #fff;border:1px solid #fff;color:#000;margin-right:5px"
                                                        mat-flat-button color="primary">
                                                        <img src="https://media.iquanta.in/ui_images/rocket.png"
                                                            alt=""
                                                            style="width: 15px; margin-right: 10px;">Resume</button>
                                                </div>
        
                                                <p *ngIf="attempt.mockStatus == 'completed'" style="color: #ffffff !important;
                                              text-align: center;
                                              margin-bottom: 10px;
                                              font-size: 14px;">Attempt {{i+1}}</p>
                                                <button *ngIf="attempt.mockStatus == 'completed'"
                                                    (click)="viewanalysis(mock, attempt, i)"
                                                    style="background-color: #fff;border:1px solid #fff;color:#000;margin-right:5px"
                                                    mat-flat-button color="primary">
                                                    View
                                                    Analysis</button>
                                            </div>
        
                                            <div *ngIf="mock.attemptAllowed && mock.attemptAllowed > mock?.attemptList?.length &&
                                                (mock.attemptList[mock.attemptList.length - 1].mockStatus == 'completed' 
                                                || !mock.attemptList[mock.attemptList.length - 1].mockStatus ) || (mock.attemptList[mock.attemptList.length - 1].mockStatus == 'started' &&
                                                !mock.attemptList[mock.attemptList.length - 1].attemptId)  ">
                                                <button
                                                    *ngIf="!mock.attemptList[mock.attemptList.length - 1].attemptId"
                                                    (click)="startMock(mock)"
                                                    style="background-color: #fff;border:1px solid #fff;color:#000;margin-right:0"
                                                    mat-flat-button color="primary">
                                                    <span><img
                                                            src="https://media.iquanta.in/ui_images/rocket.png"></span>Start
                                                    Mock</button>
                                                <button
                                                    *ngIf="mock.attemptList[mock.attemptList.length - 1].attemptId"
                                                    (click)="startMock(mock)"
                                                    style="background-color: #ffe401;border:1px solid #ffe401;color:#000;margin-right:0"
                                                    mat-flat-button color="primary">
                                                    <span><img
                                                            src="https://media.iquanta.in/ui_images/rocket.png"></span>Reattempt</button>
                                            </div>
        
                                        </div>
                                    </div>
                                    <div *ngIf="mock.attemptAllowed == 1">
                                        <div class="career_btn d-flex align-items-end">
                                            <button *ngIf="!mock.attemptList[0].attemptId" (click)="startMock(mock)"
                                                style="background-color: #fff;border:1px solid #fff;color:#000;margin-right:0"
                                                mat-flat-button color="primary">
                                                <span><img
                                                        src="https://media.iquanta.in/ui_images/rocket.png"></span>Start
                                                Mock</button>
        
                                            <button
                                                *ngIf="mock.attemptList[0].mockStatus == 'paused' || mock.attemptList[0].mockStatus == 'resumed' || mock.attemptList[0].mockStatus == 'started'"
                                                (click)="resume(mock, mock.attemptList[0], '0')"
                                                style="background-color: #fff;border:1px solid #fff;color:#000;margin-right:0"
                                                mat-flat-button color="primary">
                                                <span><img
                                                        src="https://media.iquanta.in/ui_images/rocket.png"></span>Resume</button>
        
                                            <button *ngIf="mock.attemptList[0].mockStatus == 'completed'"
                                                (click)="viewanalysis(mock, mock.attemptList[0], '0')"
                                                style="background-color: #fff;border:1px solid #fff;color:#000;margin-right:0"
                                                mat-flat-button color="primary">
                                                <span><img
                                                        src="https://media.iquanta.in/ui_images/rocket.png"></span>View
                                                Analysis</button>
                                        </div>
                                    </div>
                                    <div *ngIf="!token || !mock.attemptAllowed">
                                        <div class="career_btn d-flex align-items-end">
                                            <button (click)="startMock(mock)"
                                                style="background-color: #fff;border:1px solid #fff;color:#000;margin-right:0"
                                                mat-flat-button color="primary">
                                                <span><img
                                                        src="https://media.iquanta.in/ui_images/rocket.png"></span>Start
                                                Mock</button>
                                        </div>
                                    </div>
                                </div>
    
                                <div class="desk-none">
                                    <div class="career_btn d-flex align-items-end">
                                        <button style="background-color: #fff;border:1px solid #fff;color:#000;
                                                margin-right:0;    line-height: initial;
    padding: 0;height:auto;
    " mat-flat-button color="primary">
                                            Attempt From Desktop</button>
                                    </div>
                                </div>
                            </ng-container>
    
                            <ng-template #paidBtn3>
                                <div class="career_btn d-flex align-items-start">
                                    <button *ngIf="mock.paid"
                                        style="background-color: #f44336;border:1px solid #f44336"
                                        (click)="goto('packages')" mat-flat-button color="primary">Paid</button>
    
                                    <button [matTooltip]="'This free mock will be available from '+mock.launch"
                                        *ngIf="!mock.paid"
                                        style="background-color: #11830d;border:1px solid #11830d"
                                        mat-flat-button color="primary">Purchased</button>
                                    <button *ngIf="mock.lock" class="mobile-none"
                                        style="background-color: #fff;border:1px solid #fff;color:#000;margin-right:0"
                                        mat-flat-button color="primary">
                                        <i class="bi bi-lock-fill"></i> Locked</button>
    
    
                                    <ng-container *ngIf="mock.lock">
                                        <button class="desk-none"
                                            style="background-color: #fff;border:1px solid #fff;color:#000;margin-right:0"
                                            mat-flat-button color="primary">
                                            <i class="bi bi-lock-fill"></i> </button>
                                    </ng-container>
    
                                </div>
                            </ng-template>
    
                        </li>
                    </ng-container>
    
                </ul>
                
                <ul *ngIf="tabVal == 'bba'">
                    <ng-container *ngIf="tabVal1 == 'SET'">
                        <li class="d-flex justify-content-between"
                            *ngFor="let mock of SETMockList.slice(0, loadmore2)">
                            <div class="caree_title d-flex">
                                <h3>{{mock.name}}</h3>
                                <p *ngIf="!mock.launch" style="color: #f44336">Live Now</p>
                                <p *ngIf="mock.launch">Start Date {{mock.launch}}</p>
                            </div>
    
                            <ng-container *ngIf="!mock.launch && !mock.paid; else paidBtn1">
                                <div class="mobile-none">
                                    <div *ngIf="mock.attemptAllowed > 1">
                                        <div class="career_btn d-flex align-items-end">
        
                                            <div *ngFor="let attempt of mock.attemptList; let i = index">
                                                <div>
                                                    <p *ngIf="attempt.mockStatus == 'paused' || attempt.mockStatus == 'resumed' || (attempt.mockStatus == 'started' && attempt.attemptId)"
                                                        style="color: #ffffff !important;
                                                    text-align: center;
                                                    margin-bottom: 10px;
                                                    font-size: 14px;">Attempt {{i+1}}</p>
                                                    <button
                                                        *ngIf="attempt.mockStatus == 'paused' || attempt.mockStatus == 'resumed' || (attempt.mockStatus == 'started' && attempt.attemptId)"
                                                        (click)="resume(mock, attempt, i)"
                                                        style="background-color: #fff;border:1px solid #fff;color:#000;margin-right:5px"
                                                        mat-flat-button color="primary">
                                                        <img src="https://media.iquanta.in/ui_images/rocket.png"
                                                            alt=""
                                                            style="width: 15px; margin-right: 10px;">Resume</button>
                                                </div>
        
                                                <p *ngIf="attempt.mockStatus == 'completed'" style="color: #ffffff !important;
                                              text-align: center;
                                              margin-bottom: 10px;
                                              font-size: 14px;">Attempt {{i+1}}</p>
                                                <button *ngIf="attempt.mockStatus == 'completed'"
                                                    (click)="viewanalysis(mock, attempt, i)"
                                                    style="background-color: #fff;border:1px solid #fff;color:#000;margin-right:5px"
                                                    mat-flat-button color="primary">
                                                    View
                                                    Analysis</button>
                                            </div>
        
                                            <div *ngIf="mock.attemptAllowed && mock.attemptAllowed > mock?.attemptList?.length &&
                                                (mock.attemptList[mock.attemptList.length - 1].mockStatus == 'completed' 
                                                || !mock.attemptList[mock.attemptList.length - 1].mockStatus ) || (mock.attemptList[mock.attemptList.length - 1].mockStatus == 'started' &&
                                                !mock.attemptList[mock.attemptList.length - 1].attemptId)  ">
                                                <button
                                                    *ngIf="!mock.attemptList[mock.attemptList.length - 1].attemptId"
                                                    (click)="startMock(mock)"
                                                    style="background-color: #fff;border:1px solid #fff;color:#000;margin-right:0"
                                                    mat-flat-button color="primary">
                                                    <span><img
                                                            src="https://media.iquanta.in/ui_images/rocket.png"></span>Start
                                                    Mock</button>
                                                <button
                                                    *ngIf="mock.attemptList[mock.attemptList.length - 1].attemptId"
                                                    (click)="startMock(mock)"
                                                    style="background-color: #ffe401;border:1px solid #ffe401;color:#000;margin-right:0"
                                                    mat-flat-button color="primary">
                                                    <span><img
                                                            src="https://media.iquanta.in/ui_images/rocket.png"></span>Reattempt</button>
                                            </div>
        
                                        </div>
                                    </div>
                                    <div *ngIf="mock.attemptAllowed == 1">
                                        <div class="career_btn d-flex align-items-end">
                                            <button *ngIf="!mock.attemptList[0].attemptId" (click)="startMock(mock)"
                                                style="background-color: #fff;border:1px solid #fff;color:#000;margin-right:0"
                                                mat-flat-button color="primary">
                                                <span><img
                                                        src="https://media.iquanta.in/ui_images/rocket.png"></span>Start
                                                Mock</button>
        
                                            <button
                                                *ngIf="mock.attemptList[0].mockStatus == 'paused' || mock.attemptList[0].mockStatus == 'resumed' || mock.attemptList[0].mockStatus == 'started'"
                                                (click)="resume(mock, mock.attemptList[0], '0')"
                                                style="background-color: #fff;border:1px solid #fff;color:#000;margin-right:0"
                                                mat-flat-button color="primary">
                                                <span><img
                                                        src="https://media.iquanta.in/ui_images/rocket.png"></span>Resume</button>
        
                                            <button *ngIf="mock.attemptList[0].mockStatus == 'completed'"
                                                (click)="viewanalysis(mock, mock.attemptList[0], '0')"
                                                style="background-color: #fff;border:1px solid #fff;color:#000;margin-right:0"
                                                mat-flat-button color="primary">
                                                <span><img
                                                        src="https://media.iquanta.in/ui_images/rocket.png"></span>View
                                                Analysis</button>
                                        </div>
                                    </div>
                                    <div *ngIf="!token || !mock.attemptAllowed">
                                        <div class="career_btn d-flex align-items-end">
                                            <button (click)="startMock(mock)"
                                                style="background-color: #fff;border:1px solid #fff;color:#000;margin-right:0"
                                                mat-flat-button color="primary">
                                                <span><img
                                                        src="https://media.iquanta.in/ui_images/rocket.png"></span>Start
                                                Mock</button>
                                        </div>
                                    </div>
                                </div>
    
                                <div class="desk-none">
                                    <div class="career_btn d-flex align-items-end">
                                        <button style="background-color: #fff;border:1px solid #fff;
                                                color:#000;margin-right:0;    line-height: initial;
    padding: 0;height:auto;
    " mat-flat-button color="primary">
                                            Attempt From Desktop</button>
                                    </div>
                                </div>
                            </ng-container>
    
                            <ng-template #paidBtn1>
                                <div class="career_btn d-flex align-items-start">
                                    <button *ngIf="mock.paid"
                                        style="background-color: #f44336;border:1px solid #f44336"
                                        (click)="goto('packages')" mat-flat-button color="primary">Paid</button>
    
                                    <button [matTooltip]="'This free mock will be available from '+mock.launch"
                                        *ngIf="!mock.paid"
                                        style="background-color: #11830d;border:1px solid #11830d"
                                        mat-flat-button color="primary">Purchased</button>
                                    <button *ngIf="mock.lock" class="mobile-none"
                                        style="background-color: #fff;border:1px solid #fff;color:#000;margin-right:0"
                                        mat-flat-button color="primary">
                                        <i class="bi bi-lock-fill"></i> Locked</button>
    
    
                                    <ng-container *ngIf="mock.lock">
                                        <button class="desk-none"
                                            style="background-color: #fff;border:1px solid #fff;color:#000;margin-right:0"
                                            mat-flat-button color="primary">
                                            <i class="bi bi-lock-fill"></i> </button>
                                    </ng-container>
    
    
                                </div>
                            </ng-template>
    
                        </li>
                    </ng-container>
                  
                    <ng-container *ngIf="tabVal1 == 'NPAT'">
                        <li class="d-flex justify-content-between"
                            *ngFor="let mock of NPATMockList.slice(0, loadmore1)">
                            <div class="caree_title d-flex">
                                <h3>{{mock.name}}</h3>
                                <p *ngIf="!mock.launch" style="color: #f44336">Live Now</p>
                                <p *ngIf="mock.launch">Start Date {{mock.launch}}</p>
                            </div>
    
                            <ng-container *ngIf="!mock.launch && !mock.paid; else paidBtn3">
                                <div class="mobile-none">
                                    <div *ngIf="mock.attemptAllowed > 1">
                                        <div class="career_btn d-flex align-items-end">
        
                                            <div *ngFor="let attempt of mock.attemptList; let i = index">
                                                <div>
                                                    <p *ngIf="attempt.mockStatus == 'paused' || attempt.mockStatus == 'resumed' || (attempt.mockStatus == 'started' && attempt.attemptId)"
                                                        style="color: #ffffff !important;
                                                    text-align: center;
                                                    margin-bottom: 10px;
                                                    font-size: 14px;">Attempt {{i+1}}</p>
                                                    <button
                                                        *ngIf="attempt.mockStatus == 'paused' || attempt.mockStatus == 'resumed' || (attempt.mockStatus == 'started' && attempt.attemptId)"
                                                        (click)="resume(mock, attempt, i)"
                                                        style="background-color: #fff;border:1px solid #fff;color:#000;margin-right:5px"
                                                        mat-flat-button color="primary">
                                                        <img src="https://media.iquanta.in/ui_images/rocket.png"
                                                            alt=""
                                                            style="width: 15px; margin-right: 10px;">Resume</button>
                                                </div>
        
                                                <p *ngIf="attempt.mockStatus == 'completed'" style="color: #ffffff !important;
                                              text-align: center;
                                              margin-bottom: 10px;
                                              font-size: 14px;">Attempt {{i+1}}</p>
                                                <button *ngIf="attempt.mockStatus == 'completed'"
                                                    (click)="viewanalysis(mock, attempt, i)"
                                                    style="background-color: #fff;border:1px solid #fff;color:#000;margin-right:5px"
                                                    mat-flat-button color="primary">
                                                    View
                                                    Analysis</button>
                                            </div>
        
                                            <div *ngIf="mock.attemptAllowed && mock.attemptAllowed > mock?.attemptList?.length &&
                                                (mock.attemptList[mock.attemptList.length - 1].mockStatus == 'completed' 
                                                || !mock.attemptList[mock.attemptList.length - 1].mockStatus ) || (mock.attemptList[mock.attemptList.length - 1].mockStatus == 'started' &&
                                                !mock.attemptList[mock.attemptList.length - 1].attemptId)  ">
                                                <button
                                                    *ngIf="!mock.attemptList[mock.attemptList.length - 1].attemptId"
                                                    (click)="startMock(mock)"
                                                    style="background-color: #fff;border:1px solid #fff;color:#000;margin-right:0"
                                                    mat-flat-button color="primary">
                                                    <span><img
                                                            src="https://media.iquanta.in/ui_images/rocket.png"></span>Start
                                                    Mock</button>
                                                <button
                                                    *ngIf="mock.attemptList[mock.attemptList.length - 1].attemptId"
                                                    (click)="startMock(mock)"
                                                    style="background-color: #ffe401;border:1px solid #ffe401;color:#000;margin-right:0"
                                                    mat-flat-button color="primary">
                                                    <span><img
                                                            src="https://media.iquanta.in/ui_images/rocket.png"></span>Reattempt</button>
                                            </div>
        
                                        </div>
                                    </div>
                                    <div *ngIf="mock.attemptAllowed == 1">
                                        <div class="career_btn d-flex align-items-end">
                                            <button *ngIf="!mock.attemptList[0].attemptId" (click)="startMock(mock)"
                                                style="background-color: #fff;border:1px solid #fff;color:#000;margin-right:0"
                                                mat-flat-button color="primary">
                                                <span><img
                                                        src="https://media.iquanta.in/ui_images/rocket.png"></span>Start
                                                Mock</button>
        
                                            <button
                                                *ngIf="mock.attemptList[0].mockStatus == 'paused' || mock.attemptList[0].mockStatus == 'resumed' || mock.attemptList[0].mockStatus == 'started'"
                                                (click)="resume(mock, mock.attemptList[0], '0')"
                                                style="background-color: #fff;border:1px solid #fff;color:#000;margin-right:0"
                                                mat-flat-button color="primary">
                                                <span><img
                                                        src="https://media.iquanta.in/ui_images/rocket.png"></span>Resume</button>
        
                                            <button *ngIf="mock.attemptList[0].mockStatus == 'completed'"
                                                (click)="viewanalysis(mock, mock.attemptList[0], '0')"
                                                style="background-color: #fff;border:1px solid #fff;color:#000;margin-right:0"
                                                mat-flat-button color="primary">
                                                <span><img
                                                        src="https://media.iquanta.in/ui_images/rocket.png"></span>View
                                                Analysis</button>
                                        </div>
                                    </div>
                                    <div *ngIf="!token || !mock.attemptAllowed">
                                        <div class="career_btn d-flex align-items-end">
                                            <button (click)="startMock(mock)"
                                                style="background-color: #fff;border:1px solid #fff;color:#000;margin-right:0"
                                                mat-flat-button color="primary">
                                                <span><img
                                                        src="https://media.iquanta.in/ui_images/rocket.png"></span>Start
                                                Mock</button>
                                        </div>
                                    </div>
                                </div>
    
                                <div class="desk-none">
                                    <div class="career_btn d-flex align-items-end">
                                        <button style="background-color: #fff;border:1px solid #fff;color:#000;
                                                margin-right:0;    line-height: initial;
    padding: 0;height:auto;
    " mat-flat-button color="primary">
                                            Attempt From Desktop</button>
                                    </div>
                                </div>
                            </ng-container>
    
                            <ng-template #paidBtn3>
                                <div class="career_btn d-flex align-items-start">
                                    <button *ngIf="mock.paid"
                                        style="background-color: #f44336;border:1px solid #f44336"
                                        (click)="goto('packages')" mat-flat-button color="primary">Paid</button>
    
                                    <button [matTooltip]="'This free mock will be available from '+mock.launch"
                                        *ngIf="!mock.paid"
                                        style="background-color: #11830d;border:1px solid #11830d"
                                        mat-flat-button color="primary">Purchased</button>
                                    <button *ngIf="mock.lock" class="mobile-none"
                                        style="background-color: #fff;border:1px solid #fff;color:#000;margin-right:0"
                                        mat-flat-button color="primary">
                                        <i class="bi bi-lock-fill"></i> Locked</button>
    
    
                                    <ng-container *ngIf="mock.lock">
                                        <button class="desk-none"
                                            style="background-color: #fff;border:1px solid #fff;color:#000;margin-right:0"
                                            mat-flat-button color="primary">
                                            <i class="bi bi-lock-fill"></i> </button>
                                    </ng-container>
    
                                </div>
                            </ng-template>
    
                        </li>
                    </ng-container>
                    <ng-container *ngIf="tabVal1 == 'CHRIST'">
                        <li class="d-flex justify-content-between"
                            *ngFor="let mock of CHRISTMockList.slice(0, loadmore1)">
                            <div class="caree_title d-flex">
                                <h3>{{mock.name}}</h3>
                                <p *ngIf="!mock.launch" style="color: #f44336">Live Now</p>
                                <p *ngIf="mock.launch">Start Date {{mock.launch}}</p>
                            </div>
    
                            <ng-container *ngIf="!mock.launch && !mock.paid; else paidBtn3">
                                <div class="mobile-none">
                                    <div *ngIf="mock.attemptAllowed > 1">
                                        <div class="career_btn d-flex align-items-end">
        
                                            <div *ngFor="let attempt of mock.attemptList; let i = index">
                                                <div>
                                                    <p *ngIf="attempt.mockStatus == 'paused' || attempt.mockStatus == 'resumed' || (attempt.mockStatus == 'started' && attempt.attemptId)"
                                                        style="color: #ffffff !important;
                                                    text-align: center;
                                                    margin-bottom: 10px;
                                                    font-size: 14px;">Attempt {{i+1}}</p>
                                                    <button
                                                        *ngIf="attempt.mockStatus == 'paused' || attempt.mockStatus == 'resumed' || (attempt.mockStatus == 'started' && attempt.attemptId)"
                                                        (click)="resume(mock, attempt, i)"
                                                        style="background-color: #fff;border:1px solid #fff;color:#000;margin-right:5px"
                                                        mat-flat-button color="primary">
                                                        <img src="https://media.iquanta.in/ui_images/rocket.png"
                                                            alt=""
                                                            style="width: 15px; margin-right: 10px;">Resume</button>
                                                </div>
        
                                                <p *ngIf="attempt.mockStatus == 'completed'" style="color: #ffffff !important;
                                              text-align: center;
                                              margin-bottom: 10px;
                                              font-size: 14px;">Attempt {{i+1}}</p>
                                                <button *ngIf="attempt.mockStatus == 'completed'"
                                                    (click)="viewanalysis(mock, attempt, i)"
                                                    style="background-color: #fff;border:1px solid #fff;color:#000;margin-right:5px"
                                                    mat-flat-button color="primary">
                                                    View
                                                    Analysis</button>
                                            </div>
        
                                            <div *ngIf="mock.attemptAllowed && mock.attemptAllowed > mock?.attemptList?.length &&
                                                (mock.attemptList[mock.attemptList.length - 1].mockStatus == 'completed' 
                                                || !mock.attemptList[mock.attemptList.length - 1].mockStatus ) || (mock.attemptList[mock.attemptList.length - 1].mockStatus == 'started' &&
                                                !mock.attemptList[mock.attemptList.length - 1].attemptId)  ">
                                                <button
                                                    *ngIf="!mock.attemptList[mock.attemptList.length - 1].attemptId"
                                                    (click)="startMock(mock)"
                                                    style="background-color: #fff;border:1px solid #fff;color:#000;margin-right:0"
                                                    mat-flat-button color="primary">
                                                    <span><img
                                                            src="https://media.iquanta.in/ui_images/rocket.png"></span>Start
                                                    Mock</button>
                                                <button
                                                    *ngIf="mock.attemptList[mock.attemptList.length - 1].attemptId"
                                                    (click)="startMock(mock)"
                                                    style="background-color: #ffe401;border:1px solid #ffe401;color:#000;margin-right:0"
                                                    mat-flat-button color="primary">
                                                    <span><img
                                                            src="https://media.iquanta.in/ui_images/rocket.png"></span>Reattempt</button>
                                            </div>
        
                                        </div>
                                    </div>
                                    <div *ngIf="mock.attemptAllowed == 1">
                                        <div class="career_btn d-flex align-items-end">
                                            <button *ngIf="!mock.attemptList[0].attemptId" (click)="startMock(mock)"
                                                style="background-color: #fff;border:1px solid #fff;color:#000;margin-right:0"
                                                mat-flat-button color="primary">
                                                <span><img
                                                        src="https://media.iquanta.in/ui_images/rocket.png"></span>Start
                                                Mock</button>
        
                                            <button
                                                *ngIf="mock.attemptList[0].mockStatus == 'paused' || mock.attemptList[0].mockStatus == 'resumed' || mock.attemptList[0].mockStatus == 'started'"
                                                (click)="resume(mock, mock.attemptList[0], '0')"
                                                style="background-color: #fff;border:1px solid #fff;color:#000;margin-right:0"
                                                mat-flat-button color="primary">
                                                <span><img
                                                        src="https://media.iquanta.in/ui_images/rocket.png"></span>Resume</button>
        
                                            <button *ngIf="mock.attemptList[0].mockStatus == 'completed'"
                                                (click)="viewanalysis(mock, mock.attemptList[0], '0')"
                                                style="background-color: #fff;border:1px solid #fff;color:#000;margin-right:0"
                                                mat-flat-button color="primary">
                                                <span><img
                                                        src="https://media.iquanta.in/ui_images/rocket.png"></span>View
                                                Analysis</button>
                                        </div>
                                    </div>
                                    <div *ngIf="!token || !mock.attemptAllowed">
                                        <div class="career_btn d-flex align-items-end">
                                            <button (click)="startMock(mock)"
                                                style="background-color: #fff;border:1px solid #fff;color:#000;margin-right:0"
                                                mat-flat-button color="primary">
                                                <span><img
                                                        src="https://media.iquanta.in/ui_images/rocket.png"></span>Start
                                                Mock</button>
                                        </div>
                                    </div>
                                </div>
    
                                <div class="desk-none">
                                    <div class="career_btn d-flex align-items-end">
                                        <button style="background-color: #fff;border:1px solid #fff;color:#000;
                                                margin-right:0;    line-height: initial;
    padding: 0;height:auto;
    " mat-flat-button color="primary">
                                            Attempt From Desktop</button>
                                    </div>
                                </div>
                            </ng-container>
    
                            <ng-template #paidBtn3>
                                <div class="career_btn d-flex align-items-start">
                                    <button *ngIf="mock.paid"
                                        style="background-color: #f44336;border:1px solid #f44336"
                                        (click)="goto('packages')" mat-flat-button color="primary">Paid</button>
    
                                    <button [matTooltip]="'This free mock will be available from '+mock.launch"
                                        *ngIf="!mock.paid"
                                        style="background-color: #11830d;border:1px solid #11830d"
                                        mat-flat-button color="primary">Purchased</button>
                                    <button *ngIf="mock.lock" class="mobile-none"
                                        style="background-color: #fff;border:1px solid #fff;color:#000;margin-right:0"
                                        mat-flat-button color="primary">
                                        <i class="bi bi-lock-fill"></i> Locked</button>
    
    
                                    <ng-container *ngIf="mock.lock">
                                        <button class="desk-none"
                                            style="background-color: #fff;border:1px solid #fff;color:#000;margin-right:0"
                                            mat-flat-button color="primary">
                                            <i class="bi bi-lock-fill"></i> </button>
                                    </ng-container>
    
                                </div>
                            </ng-template>
    
                        </li>
                    </ng-container>
    
                    <ng-container *ngIf="tabVal1 == 'BMSBBA'">
                        <li class="d-flex justify-content-between"
                            *ngFor="let mock of BMSBBAMockList.slice(0, loadmore1)">
                            <div class="caree_title d-flex">
                                <h3>{{mock.name}}</h3>
                                <p *ngIf="!mock.launch" style="color: #f44336">Live Now</p>
                                <p *ngIf="mock.launch">Start Date {{mock.launch}}</p>
                            </div>
    
                            <ng-container *ngIf="!mock.launch && !mock.paid; else paidBtn3">
                                <div class="mobile-none">
                                    <div *ngIf="mock.attemptAllowed > 1">
                                        <div class="career_btn d-flex align-items-end">
        
                                            <div *ngFor="let attempt of mock.attemptList; let i = index">
                                                <div>
                                                    <p *ngIf="attempt.mockStatus == 'paused' || attempt.mockStatus == 'resumed' || (attempt.mockStatus == 'started' && attempt.attemptId)"
                                                        style="color: #ffffff !important;
                                                    text-align: center;
                                                    margin-bottom: 10px;
                                                    font-size: 14px;">Attempt {{i+1}}</p>
                                                    <button
                                                        *ngIf="attempt.mockStatus == 'paused' || attempt.mockStatus == 'resumed' || (attempt.mockStatus == 'started' && attempt.attemptId)"
                                                        (click)="resume(mock, attempt, i)"
                                                        style="background-color: #fff;border:1px solid #fff;color:#000;margin-right:5px"
                                                        mat-flat-button color="primary">
                                                        <img src="https://media.iquanta.in/ui_images/rocket.png"
                                                            alt=""
                                                            style="width: 15px; margin-right: 10px;">Resume</button>
                                                </div>
        
                                                <p *ngIf="attempt.mockStatus == 'completed'" style="color: #ffffff !important;
                                              text-align: center;
                                              margin-bottom: 10px;
                                              font-size: 14px;">Attempt {{i+1}}</p>
                                                <button *ngIf="attempt.mockStatus == 'completed'"
                                                    (click)="viewanalysis(mock, attempt, i)"
                                                    style="background-color: #fff;border:1px solid #fff;color:#000;margin-right:5px"
                                                    mat-flat-button color="primary">
                                                    View
                                                    Analysis</button>
                                            </div>
        
                                            <div *ngIf="mock.attemptAllowed && mock.attemptAllowed > mock?.attemptList?.length &&
                                                (mock.attemptList[mock.attemptList.length - 1].mockStatus == 'completed' 
                                                || !mock.attemptList[mock.attemptList.length - 1].mockStatus ) || (mock.attemptList[mock.attemptList.length - 1].mockStatus == 'started' &&
                                                !mock.attemptList[mock.attemptList.length - 1].attemptId)  ">
                                                <button
                                                    *ngIf="!mock.attemptList[mock.attemptList.length - 1].attemptId"
                                                    (click)="startMock(mock)"
                                                    style="background-color: #fff;border:1px solid #fff;color:#000;margin-right:0"
                                                    mat-flat-button color="primary">
                                                    <span><img
                                                            src="https://media.iquanta.in/ui_images/rocket.png"></span>Start
                                                    Mock</button>
                                                <button
                                                    *ngIf="mock.attemptList[mock.attemptList.length - 1].attemptId"
                                                    (click)="startMock(mock)"
                                                    style="background-color: #ffe401;border:1px solid #ffe401;color:#000;margin-right:0"
                                                    mat-flat-button color="primary">
                                                    <span><img
                                                            src="https://media.iquanta.in/ui_images/rocket.png"></span>Reattempt</button>
                                            </div>
        
                                        </div>
                                    </div>
                                    <div *ngIf="mock.attemptAllowed == 1">
                                        <div class="career_btn d-flex align-items-end">
                                            <button *ngIf="!mock.attemptList[0].attemptId" (click)="startMock(mock)"
                                                style="background-color: #fff;border:1px solid #fff;color:#000;margin-right:0"
                                                mat-flat-button color="primary">
                                                <span><img
                                                        src="https://media.iquanta.in/ui_images/rocket.png"></span>Start
                                                Mock</button>
        
                                            <button
                                                *ngIf="mock.attemptList[0].mockStatus == 'paused' || mock.attemptList[0].mockStatus == 'resumed' || mock.attemptList[0].mockStatus == 'started'"
                                                (click)="resume(mock, mock.attemptList[0], '0')"
                                                style="background-color: #fff;border:1px solid #fff;color:#000;margin-right:0"
                                                mat-flat-button color="primary">
                                                <span><img
                                                        src="https://media.iquanta.in/ui_images/rocket.png"></span>Resume</button>
        
                                            <button *ngIf="mock.attemptList[0].mockStatus == 'completed'"
                                                (click)="viewanalysis(mock, mock.attemptList[0], '0')"
                                                style="background-color: #fff;border:1px solid #fff;color:#000;margin-right:0"
                                                mat-flat-button color="primary">
                                                <span><img
                                                        src="https://media.iquanta.in/ui_images/rocket.png"></span>View
                                                Analysis</button>
                                        </div>
                                    </div>
                                    <div *ngIf="!token || !mock.attemptAllowed">
                                        <div class="career_btn d-flex align-items-end">
                                            <button (click)="startMock(mock)"
                                                style="background-color: #fff;border:1px solid #fff;color:#000;margin-right:0"
                                                mat-flat-button color="primary">
                                                <span><img
                                                        src="https://media.iquanta.in/ui_images/rocket.png"></span>Start
                                                Mock</button>
                                        </div>
                                    </div>
                                </div>
    
                                <div class="desk-none">
                                    <div class="career_btn d-flex align-items-end">
                                        <button style="background-color: #fff;border:1px solid #fff;color:#000;
                                                margin-right:0;    line-height: initial;
                                            padding: 0;height:auto;
                                            " mat-flat-button color="primary">
                                            Attempt From Desktop</button>
                                    </div>
                                </div>
                            </ng-container>
    
                            <ng-template #paidBtn3>
                                <div class="career_btn d-flex align-items-start">
                                    <button *ngIf="mock.paid"
                                        style="background-color: #f44336;border:1px solid #f44336"
                                        (click)="goto('packages')" mat-flat-button color="primary">Paid</button>
    
                                    <button [matTooltip]="'This free mock will be available from '+mock.launch"
                                        *ngIf="!mock.paid"
                                        style="background-color: #11830d;border:1px solid #11830d"
                                        mat-flat-button color="primary">Purchased</button>
                                    <button *ngIf="mock.lock" class="mobile-none"
                                        style="background-color: #fff;border:1px solid #fff;color:#000;margin-right:0"
                                        mat-flat-button color="primary">
                                        <i class="bi bi-lock-fill"></i> Locked</button>
    
    
                                    <ng-container *ngIf="mock.lock">
                                        <button class="desk-none"
                                            style="background-color: #fff;border:1px solid #fff;color:#000;margin-right:0"
                                            mat-flat-button color="primary">
                                            <i class="bi bi-lock-fill"></i> </button>
                                    </ng-container>
    
                                </div>
                            </ng-template>
    
                        </li>
                    </ng-container>
    
                    <ng-container *ngIf="tabVal1 == 'CETBBA'">
                        <li class="d-flex justify-content-between"
                            *ngFor="let mock of CETBBAMockList.slice(0, loadmore1)">
                            <div class="caree_title d-flex">
                                <h3>{{mock.name}}</h3>
                                <p *ngIf="!mock.launch" style="color: #f44336">Live Now</p>
                                <p *ngIf="mock.launch">Start Date {{mock.launch}}</p>
                            </div>
    
                            <ng-container *ngIf="!mock.launch && !mock.paid; else paidBtn3">
                                <div class="mobile-none">
                                    <div *ngIf="mock.attemptAllowed > 1">
                                        <div class="career_btn d-flex align-items-end">
        
                                            <div *ngFor="let attempt of mock.attemptList; let i = index">
                                                <div>
                                                    <p *ngIf="attempt.mockStatus == 'paused' || attempt.mockStatus == 'resumed' || (attempt.mockStatus == 'started' && attempt.attemptId)"
                                                        style="color: #ffffff !important;
                                                    text-align: center;
                                                    margin-bottom: 10px;
                                                    font-size: 14px;">Attempt {{i+1}}</p>
                                                    <button
                                                        *ngIf="attempt.mockStatus == 'paused' || attempt.mockStatus == 'resumed' || (attempt.mockStatus == 'started' && attempt.attemptId)"
                                                        (click)="resume(mock, attempt, i)"
                                                        style="background-color: #fff;border:1px solid #fff;color:#000;margin-right:5px"
                                                        mat-flat-button color="primary">
                                                        <img src="https://media.iquanta.in/ui_images/rocket.png"
                                                            alt=""
                                                            style="width: 15px; margin-right: 10px;">Resume</button>
                                                </div>
        
                                                <p *ngIf="attempt.mockStatus == 'completed'" style="color: #ffffff !important;
                                              text-align: center;
                                              margin-bottom: 10px;
                                              font-size: 14px;">Attempt {{i+1}}</p>
                                                <button *ngIf="attempt.mockStatus == 'completed'"
                                                    (click)="viewanalysis(mock, attempt, i)"
                                                    style="background-color: #fff;border:1px solid #fff;color:#000;margin-right:5px"
                                                    mat-flat-button color="primary">
                                                    View
                                                    Analysis</button>
                                            </div>
        
                                            <div *ngIf="mock.attemptAllowed && mock.attemptAllowed > mock?.attemptList?.length &&
                                                (mock.attemptList[mock.attemptList.length - 1].mockStatus == 'completed' 
                                                || !mock.attemptList[mock.attemptList.length - 1].mockStatus ) || (mock.attemptList[mock.attemptList.length - 1].mockStatus == 'started' &&
                                                !mock.attemptList[mock.attemptList.length - 1].attemptId)  ">
                                                <button
                                                    *ngIf="!mock.attemptList[mock.attemptList.length - 1].attemptId"
                                                    (click)="startMock(mock)"
                                                    style="background-color: #fff;border:1px solid #fff;color:#000;margin-right:0"
                                                    mat-flat-button color="primary">
                                                    <span><img
                                                            src="https://media.iquanta.in/ui_images/rocket.png"></span>Start
                                                    Mock</button>
                                                <button
                                                    *ngIf="mock.attemptList[mock.attemptList.length - 1].attemptId"
                                                    (click)="startMock(mock)"
                                                    style="background-color: #ffe401;border:1px solid #ffe401;color:#000;margin-right:0"
                                                    mat-flat-button color="primary">
                                                    <span><img
                                                            src="https://media.iquanta.in/ui_images/rocket.png"></span>Reattempt</button>
                                            </div>
        
                                        </div>
                                    </div>
                                    <div *ngIf="mock.attemptAllowed == 1">
                                        <div class="career_btn d-flex align-items-end">
                                            <button *ngIf="!mock.attemptList[0].attemptId" (click)="startMock(mock)"
                                                style="background-color: #fff;border:1px solid #fff;color:#000;margin-right:0"
                                                mat-flat-button color="primary">
                                                <span><img
                                                        src="https://media.iquanta.in/ui_images/rocket.png"></span>Start
                                                Mock</button>
        
                                            <button
                                                *ngIf="mock.attemptList[0].mockStatus == 'paused' || mock.attemptList[0].mockStatus == 'resumed' || mock.attemptList[0].mockStatus == 'started'"
                                                (click)="resume(mock, mock.attemptList[0], '0')"
                                                style="background-color: #fff;border:1px solid #fff;color:#000;margin-right:0"
                                                mat-flat-button color="primary">
                                                <span><img
                                                        src="https://media.iquanta.in/ui_images/rocket.png"></span>Resume</button>
        
                                            <button *ngIf="mock.attemptList[0].mockStatus == 'completed'"
                                                (click)="viewanalysis(mock, mock.attemptList[0], '0')"
                                                style="background-color: #fff;border:1px solid #fff;color:#000;margin-right:0"
                                                mat-flat-button color="primary">
                                                <span><img
                                                        src="https://media.iquanta.in/ui_images/rocket.png"></span>View
                                                Analysis</button>
                                        </div>
                                    </div>
                                    <div *ngIf="!token || !mock.attemptAllowed">
                                        <div class="career_btn d-flex align-items-end">
                                            <button (click)="startMock(mock)"
                                                style="background-color: #fff;border:1px solid #fff;color:#000;margin-right:0"
                                                mat-flat-button color="primary">
                                                <span><img
                                                        src="https://media.iquanta.in/ui_images/rocket.png"></span>Start
                                                Mock</button>
                                        </div>
                                    </div>
                                </div>
    
                                <div class="desk-none">
                                    <div class="career_btn d-flex align-items-end">
                                        <button style="background-color: #fff;border:1px solid #fff;color:#000;
                                                margin-right:0;    line-height: initial;
                                        padding: 0;height:auto;
                                        " mat-flat-button color="primary">
                                            Attempt From Desktop</button>
                                    </div>
                                </div>
                            </ng-container>
    
                            <ng-template #paidBtn3>
                                <div class="career_btn d-flex align-items-start">
                                    <button *ngIf="mock.paid"
                                        style="background-color: #f44336;border:1px solid #f44336"
                                        (click)="goto('packages')" mat-flat-button color="primary">Paid</button>
    
                                    <button [matTooltip]="'This free mock will be available from '+mock.launch"
                                        *ngIf="!mock.paid"
                                        style="background-color: #11830d;border:1px solid #11830d"
                                        mat-flat-button color="primary">Purchased</button>
                                    <button *ngIf="mock.lock" class="mobile-none"
                                        style="background-color: #fff;border:1px solid #fff;color:#000;margin-right:0"
                                        mat-flat-button color="primary">
                                        <i class="bi bi-lock-fill"></i> Locked</button>
    
    
                                    <ng-container *ngIf="mock.lock">
                                        <button class="desk-none"
                                            style="background-color: #fff;border:1px solid #fff;color:#000;margin-right:0"
                                            mat-flat-button color="primary">
                                            <i class="bi bi-lock-fill"></i> </button>
                                    </ng-container>
    
                                </div>
                            </ng-template>
    
                        </li>
                    </ng-container>
               
    
                </ul>
    
            </div>
    
    
        </div>
        <div class="col-md-9">
            <div class="load-more">
                <button *ngIf="tabVal == 'full' && loadmore1 < fullmockDetailList.length" mat-button
                    (click)="loadmore()">Load More</button>
    
                <button *ngIf="tabVal == 'full' && loadmore1 == fullmockDetailList.length" mat-button
                    (click)="loadless()">Load Less</button>
    
                <button  *ngIf="tabVal == 'sectional' && (loadmore2 < quantMockList.length || loadmore2 < varcMockList.length || loadmore2 < lrdiMockList.length)"
                    mat-button (click)="loadmore()">Load More</button>
               
                <button *ngIf="tabVal == 'sectional' && (loadmore2 == quantMockList.length || loadmore2 ==  varcMockList.length || loadmore2 == lrdiMockList.length)"
                    mat-button (click)="loadless()">Load Less</button>
                  
               <button *ngIf="tabVal == 'bba' && (loadmore2 < SETMockList.length || loadmore2 < XETMockList.length || loadmore2 < NPATMockList.length || loadmore2 < CHRISTMockList.length || loadmore2 < IPUMockList.length)"
                    mat-button (click)="loadmore()">Load More</button>
    
               <button *ngIf="tabVal == 'bba' && (loadmore2 == SETMockList.length || loadmore2 ==  XETMockList.length || loadmore2 == NPATMockList.length || loadmore2 == CHRISTMockList.length || loadmore2 == IPUMockList.length)"
                    mat-button (click)="loadless()">Load Less</button>
            </div>
        </div>
    </div>
</div>

<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#fff" type="square-jelly-box" [fullScreen]="true">
    <p style="color: white;text-align: center;font-size:30px"> <b>Loading...</b> </p>
    <p style="color: white; text-align: center;font-size:10px"> <b> Note: </b> <br> If this Screen freezes <br> Refresh
        the page, Logout and Login again... </p>
</ngx-spinner>